// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-11-03T21:40:33.395Z
// Property: Crestview Commons (ID: 6767906449166975)
// Collections: 11 amenities, 3 floorplans (live), 31 photos, 67 POIs, 4 reviews, 6 office hours, 1 special offers (live)
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5734677587427328",
  "multihub_property_id": "6767906449166975",
  "property_external_id": "5599107",
  "property_zillow_url": null,
  "property_apartments_url": "https://www.apartments.com/crestview-commons-elk-city-ok/2d8cn59/",
  "property_google_business_url": "https://www.google.com/maps/place/Crestview+Commons/data=!4m2!3m1!1s0x0:0x5d4af048bac757ae?sa=X&ved=2ahUKEwiK_uKw0bySAxUG6BoGHYkXL5YQ_BJ6BAgXEAA&hl=en&gl=us",
  "property_linkedin_url": null,
  "property_hubspot_id": "45778902314",
  "property_crm_software": "Knock",
  "property_pm_software": "RealPage",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "crestview-commons",
  "property_name": "Crestview Commons",
  "property_website_url": "https://www.crestviewcommonsapts.com/",
  "property_domain": "https://www.crestviewcommonsapts.com/",
  "property_address": "2302 W Country Club Blvd",
  "property_full_address": "2302 W Country Club Blvd, Elk City, OK 73644",
  "property_address_1": "2302 W Country Club Blvd",
  "property_address_2": null,
  "property_address_city": "Elk City",
  "property_address_state": "OK",
  "property_address_zip_full": null,
  "property_address_zip": "73644",
  "property_address_country": "US",
  "property_address_county": "Beckham County",
  "property_neighborhood_address": null,
  "property_address_latitude": "35.4205121",
  "property_address_longitude": "-99.43288199999999",
  "property_email": "Crestviewcommons@rrliving.com",
  "property_phone": "580-225-4495",
  "property_call_tracking_phone": "580-789-2906",
  "property_company_name": "RR Living",
  "property_company_url": "https://www.rrliving.com/",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "Welcome to Crestview Commons in Elk City, OK, where modern living meets comfort. Choose from chic one and two-bedroom floor plans featuring high ceilings, designer finishes, and energy-efficient appliances. Enjoy on-site maintenance, a refreshing pool, and smoke-free living. Find your new home today—browse availability or schedule a tour!",
  "property_long_description": "Welcome to Crestview Commons, where modern living meets exceptional convenience in the heart of Elk City, OK! Our thoughtfully designed apartment community offers a variety of spacious floor plans, including one and two-bedroom options, perfect for individuals and families alike. \n\nAt Crestview Commons, we take pride in creating a smoke-free environment that prioritizes your comfort and wellbeing. Enjoy the luxury of maintenance on-site for your peace of mind, and dive into relaxation with our inviting community pool. With on-site laundry facilities and a dedicated property manager, we ensure your every need is met with ease. \n\nExperience the elegance of designer-selected modern finishes throughout your apartment, featuring expansive 9-foot ceilings and gorgeous wood plank-style flooring. Our energy-efficient units come equipped with essential appliances, such as a microwave oven, refrigerator, and dishwasher, along with superior heating and cooling systems. The breakfast bar provides a perfect spot for casual dining, while high-speed internet and cable readiness keep you connected seamlessly.\n\nMake Crestview Commons your new home and enjoy a vibrant community with exceptional amenities! Don’t miss out on your chance to live in this fantastic location. Reach out today to find your new home—browse our available units or schedule a personal tour of our remarkable community. Your perfect apartment awaits at Crestview Commons!",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166975/019d08b6-03a7-70ca-8e7d-a20520e2a5db.webp",
  "property_featured_image_media": {
    "alt_text": "Living room with sliding glass door and vertical blinds",
    "public_id": "019d08b6-03a7-70ca-8e7d-a20520e2a5db",
    "storage_key": "property/6767906449166975/019d08b6-03a7-70ca-8e7d-a20520e2a5db.webp",
    "width": 1500,
    "height": 1000
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "79",
  "property_year_built": null,
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "65.82278481012658",
  "property_admin_fee": null,
  "property_application_fee": null,
  "property_fees_deposit_info": null,
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "250",
  "property_pet_deposit": null,
  "property_monthly_pet_rent": "25",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": "50",
  "property_pet_restrictions": "Maximum 2 pets per unit. Weight limit: 50 lb per pet.",
  "property_pet_policy_description": "<p>RR Living knows the importance of pets to their fur-parents, so we prioritize them in the living experience at our communities.</p><p>Our residents enjoy Bark Parks, SantaPaws Events and Treats & Tails Socials. Learn more about our <a href=\"https://app.petscreening.com\">pet policy</a> through our partner, <a href=\"https://app.petscreening.com\">PetScreening</a>.</p><p>We are proud to offer no breed restrictions at this community. Maximum of 2 pets per home. A non-refundable, one-time pet fee is required for each pet. Veterinary documentation may be requested.</p>",
  "property_petpolicy_info": null,
  "property_online_leasing_url": null,
  "property_resident_portal_url": "https://crestviewcommons.loftliving.com/login",
  "property_apply_now_url": "https://9273741.onlineleasing.realpage.com/",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166975/019ea7e6-880f-7173-804e-9f2a646f5f67.webp",
  "property_primary_logo_media": {
    "alt_text": "Crestview Commons Apartments logo",
    "public_id": "019ea7e6-880f-7173-804e-9f2a646f5f67",
    "storage_key": "property/6767906449166975/019ea7e6-880f-7173-804e-9f2a646f5f67.webp",
    "width": 2380,
    "height": 2184
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166975/019ea7e6-aa5f-7578-bb56-58124ba918fd.webp",
  "property_secondary_logo_media": {
    "alt_text": "Crestview Commons Apartments logo",
    "public_id": "019ea7e6-aa5f-7578-bb56-58124ba918fd",
    "storage_key": "property/6767906449166975/019ea7e6-aa5f-7578-bb56-58124ba918fd.webp",
    "width": 2380,
    "height": 2183
  },
  "property_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166975/019fb451-f8c9-7271-ba49-96f07436c433.webp",
  "property_icon_media": {
    "alt_text": "C logo",
    "public_id": "019fb451-f8c9-7271-ba49-96f07436c433",
    "storage_key": "property/6767906449166975/019fb451-f8c9-7271-ba49-96f07436c433.webp",
    "width": 577,
    "height": 640
  },
  "property_fav_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166975/019fb451-f8c9-7271-ba49-96f07436c433.webp",
  "property_fav_icon_media": {
    "alt_text": "C logo",
    "public_id": "019fb451-f8c9-7271-ba49-96f07436c433",
    "storage_key": "property/6767906449166975/019fb451-f8c9-7271-ba49-96f07436c433.webp",
    "width": 577,
    "height": 640
  },
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166975/019ea7e6-87c4-7713-a812-e02f67cdce9d.webp",
  "property_mono_white_logo_media": {
    "alt_text": "Crestview Commons Apartments logo",
    "public_id": "019ea7e6-87c4-7713-a812-e02f67cdce9d",
    "storage_key": "property/6767906449166975/019ea7e6-87c4-7713-a812-e02f67cdce9d.webp",
    "width": 2380,
    "height": 2184
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166975/019ea7e6-880f-7173-804e-9f2a646f5f67.webp",
  "property_mono_black_logo_media": {
    "alt_text": "Crestview Commons Apartments logo",
    "public_id": "019ea7e6-880f-7173-804e-9f2a646f5f67",
    "storage_key": "property/6767906449166975/019ea7e6-880f-7173-804e-9f2a646f5f67.webp",
    "width": 2380,
    "height": 2184
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5734677587427328/019d595d-b89d-716c-8cb0-24426d93f0d6.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5734677587427328/019d595e-2b5f-71d5-85c8-a7b454bb3a35.webp",
  "property_company_logo_media": {
    "alt_text": "RR Living logo",
    "public_id": "019d595e-2b5f-71d5-85c8-a7b454bb3a35",
    "storage_key": "company/5734677587427328/019d595e-2b5f-71d5-85c8-a7b454bb3a35.webp",
    "width": 1500,
    "height": 1500
  },
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5734677587427328/019d595e-2b5f-71d5-85c8-a7b454bb3a35.webp",
  "property_company_mono_black_logo_media": {
    "alt_text": "RR Living logo",
    "public_id": "019d595e-2b5f-71d5-85c8-a7b454bb3a35",
    "storage_key": "company/5734677587427328/019d595e-2b5f-71d5-85c8-a7b454bb3a35.webp",
    "width": 1500,
    "height": 1500
  },
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5734677587427328/019d06ca-1e49-754a-93ba-7ae4659a0d68.webp",
  "property_company_mono_white_logo_media": {
    "alt_text": "RR Living logo with RRL text",
    "public_id": "019d06ca-1e49-754a-93ba-7ae4659a0d68",
    "storage_key": "company/5734677587427328/019d06ca-1e49-754a-93ba-7ae4659a0d68.webp",
    "width": 640,
    "height": 640
  },
  "property_primary_color": "#111532",
  "property_secondary_color": "#93221e",
  "property_font_color": null,
  "property_color_4": "#f0f2f4",
  "property_color_3": "#fedb8a",
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "1 - 2",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "3",
  "property_bathrooms_range": "1",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "525 - 955",
  "property_sqft_min": "525",
  "property_sqft_max": "1050",
  "property_price_range": "575 - 710",
  "property_price_min": "575",
  "property_price_max": "710",
  "property_available_units": 27,
  "property_facebook_url": "https://www.facebook.com/CrestviewCommonsOK/",
  "property_instagram_url": "https://www.instagram.com/crestviewcommonsapts/",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJD_FyHBblq4cRrlfHukjwSl0",
  "property_youtube_url": null,
  "property_yelp_url": "https://www.yelp.com/search?find_desc=Apartments&find_loc=Elk+City%2C+OK+73644",
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Crestview Commons",
  "property_home_romance_title": "Embrace the Charm of Your New Apartment Community Today",
  "property_home_amenities_blurb": "<p>Welcome to Crestview Commons, ideally situated in the heart of Elk City with convenient access to schools, parks, churches, and shopping centers. Choose from our selection of <a href=\"/floor-plans/\">one- and two-bedroom units to suit your needs</a>.</p>",
  "property_home_floorplans_blurb": "<p>At Crestview Commons in Elk City, OK, our <a href=\"/floor-plans/\">thoughtfully designed floor plans</a> cater to your lifestyle. Whether you seek the cozy charm of a one-bedroom retreat or the spaciousness of a two-bedroom sanctuary, each layout invites comfort and connection. Browse our available apartment homes and find your perfect floor plan today!</p>",
  "property_home_gallery_blurb": "<p>At Crestview Commons in Elk City, OK, imagine a life where modern comforts meet inviting <a href=\"/amenities/\">amenities</a>. With stylish one and two-bedroom floor plans, enjoy 9-foot ceilings, designer finishes, and a smoke-free environment. Relax by the pool or savor meals at the breakfast bar. <a href=\"/gallery/\">Picture yourself</a> living here!</p>",
  "property_home_neighborhood_blurb": "Welcome to Crestview Commons in charming Elk City, OK! Surround yourself with vibrant community treasures, including parks, esteemed schools, and recreational hotspots like Ackley Park and Elk City Golf & Country Club. Embrace a lifestyle enriched by convenience and connection, and see what makes our community truly special.",
  "property_home_reviews_blurb": "At Crestview Commons in Elk City, OK, our residents rave about our “super friendly staff and quick responses.” With a 5-star rating, living here means enjoying a supportive community and prompt maintenance when you need it. Want to know more? Hear directly from our happy residents today!",
  "property_neighborhood_blurb": "<p>Welcome to Crestview Commons in charming Elk City, OK! Surround yourself with vibrant community treasures, including parks, esteemed schools, and recreational hotspots like Ackley Park and Elk City Golf & Country Club. Embrace a lifestyle enriched by convenience and connection, and see what makes our community truly special.</p>",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "<p>Welcome to Crestview Commons in Elk City, OK, where modern living meets comfort. Choose between spacious one and two-bedroom <a href=\"/floor-plans/\">floor plans</a> featuring stylish finishes, high-speed internet, and smoke-free living. Dive into our refreshing pool or relax in designer spaces with 9-foot ceilings and wood-style flooring. Experience the Crestview difference!</p>",
  "property_applynow_blurb": "At Crestview Commons in Elk City, OK, modern living meets comfort. Choose from thoughtfully designed one and two-bedroom floor plans featuring 9-foot ceilings and stylish wood plank flooring. Enjoy smoke-free amenities, a refreshing pool, and on-site maintenance. Find your new home and lease online today!",
  "property_contactus_blurb": "At Crestview Commons in Elk City, OK, our thoughtfully designed floor plans cater to your lifestyle. Choose from spacious one or two-bedroom apartments that blend comfort with modern living. Have questions? Reach out to our friendly leasing team today and let us help you find your perfect home!",
  "property_faqs_blurb": "At Crestview Commons in Elk City, OK, we offer thoughtfully designed one and two-bedroom floor plans tailored to your lifestyle. Have questions about our community? Our FAQs page is your go-to resource, providing insights to help you find your perfect home. Your comfort and convenience are just a click away!",
  "property_floorplans_blurb": "<p>At Crestview Commons in Elk City, OK, our thoughtfully designed floor plans cater to your lifestyle. Whether you seek the cozy charm of a one-bedroom retreat or the spaciousness of a two-bedroom sanctuary, each layout invites comfort and connection. Browse our available apartment homes and find your perfect floor plan today!</p>",
  "property_gallery_blurb": "<p>At Crestview Commons in Elk City, OK, imagine a life where modern comforts meet inviting <a href=\"/amenities/\">amenities</a>. With stylish one and two-bedroom floor plans, enjoy 9-foot ceilings, designer finishes, and a smoke-free environment. Relax by the pool or savor meals at the breakfast bar. <a href=\"/gallery/\">Picture</a> yourself living here!</p>",
  "property_interactivemap_blurb": "At Crestview Commons in Elk City, OK, modern living meets comfort. Choose from stylish one and two-bedroom floor plans featuring designer finishes, smoke-free environments, and 9-foot ceilings. With amenities like a refreshing pool, on-site maintenance, and high-speed internet, your perfect home awaits. Check our interactive community map to explore!",
  "property_pets_blurb": "<p>RR Living knows the importance of pets to their fur-parents, so we prioritize them in the living experience at our communities.</p><p>Our residents enjoy Bark Parks, SantaPaws Events and Treats & Tails Socials. Learn more about our <a href=\"https://app.petscreening.com\">pet policy</a> through our partner, <a href=\"https://app.petscreening.com\">PetScreening</a>.</p><p>We are proud to offer no breed restrictions at this community. Maximum of 2 pets per home. A non-refundable, one-time pet fee is required for each pet. Veterinary documentation may be requested.</p>",
  "property_referafriend_blurb": "At Crestview Commons in Elk City, OK, vibrant living awaits you in our thoughtfully designed one and two-bedroom apartments. Share the joy of community with those who matter most—refer a friend today and enhance the essence of home together. Great friends make great neighbors! Join us in creating lasting memories.",
  "property_residentaccess_blurb": "At Crestview Commons in Elk City, OK, our thoughtfully designed one and two-bedroom floor plans offer the perfect blend of comfort and style. Enhance your living experience and easily manage your home by logging into the resident portal—pay rent, schedule maintenance, and enjoy seamless community living today!",
  "property_reviews_blurb": "At Crestview Commons in Elk City, OK, our residents rave about the “super friendly staff and quick responses.” With a perfect rating of 5, we pride ourselves on swift service and a welcoming atmosphere. Curious about our community? See what our residents have to say about living here!",
  "property_created_at": "1767903808048",
  "property_scheduletour_blurb": "At Crestview Commons in Elk City, OK, we offer thoughtfully designed one and two-bedroom floor plans that cater to your lifestyle. Ready to elevate your living experience? Schedule a tour today and check out what our residents love most about calling our community home!",
  "property_thankyou_blurb": "Thank you for your interest in Crestview Commons, where stylish living meets comfort in Elk City, OK. With thoughtfully designed one and two-bedroom floor plans, your perfect home awaits. A team member will reach out soon to guide you towards your new lifestyle at Crestview Commons!",
  "property_virtualtours_blurb": "Welcome to Crestview Commons in Elk City, OK, where comfort meets style. Choose from our spacious one and two-bedroom floor plans designed to fit your lifestyle. Elevate your experience by taking a virtual tour of our vibrant community and find your next home today!",
  "property_copyright": "2026 All Rights Reserved. Crestview Commons",
  "property_seo_title_home": "Crestview Commons |  Apartments in Elk City, OK",
  "property_seo_description_home": "Welcome to Crestview Commons, Elk City's smoke-free haven! Enjoy modern amenities, poolside relaxation, and spacious floor plans. Find your new home today!",
  "property_seo_title_floorplans": "Floor Plans | Elk City, OK Apartments for Rent",
  "property_seo_description_floorplans": "Find your ideal space at Crestview Commons in Elk City, OK! Choose from stylish one and two-bedroom floor plans designed for comfort and modern living.",
  "property_seo_title_amenities": "Amenities | Elk City, OK Apartments for Rent",
  "property_seo_description_amenities": "Experience modern comfort at Crestview Commons in Elk City! Enjoy our smoke-free lifestyle, sparkling pool, and stylish apartments with top-notch amenities.",
  "property_seo_title_gallery": "Gallery | Apartments in Elk City, OK",
  "property_seo_description_gallery": "Envision life at Crestview Commons in Elk City, OK! Modern finishes, spacious designs, and inviting amenities await. Your new home starts with a picture!",
  "property_seo_title_virtualtours": "Virtual Tours | Crestview Commons Apartments",
  "property_seo_description_virtualtours": "Step into Crestview Commons in Elk City, OK! Experience our one and two-bedroom apartments through a virtual tour—your dream home awaits!",
  "property_seo_title_interactivemap": "Interactive Map | Crestview Commons Apartments",
  "property_seo_description_interactivemap": "Find your perfect home at Crestview Commons in Elk City, OK! Use our interactive map to explore spacious one and two-bedroom apartments with modern amenities.",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Elk City, OK",
  "property_seo_description_neighborhood": "Uncover Elk City’s hidden gems near Crestview Commons. From cozy cafes to scenic parks, find your favorite spots and experience vibrant community living!",
  "property_seo_title_contact": "Contact Us | Crestview Commons",
  "property_seo_description_contact": "Reach out to Crestview Commons in Elk City, OK! Our leasing team is ready to answer your questions about our one and two-bedroom floor plans. Let's connect!",
  "property_seo_title_faqs": "FAQs | Apartments in Elk City, OK",
  "property_seo_description_faqs": "Uncover answers about Crestview Commons in Elk City, OK! From floor plans to amenities, learn why your next home could be just a click away.",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Elk City, OK",
  "property_seo_description_reviews": "Experience Crestview Commons in Elk City, OK. Residents love our smoke-free community, modern finishes, and amenities like a pool & on-site maintenance.",
  "property_seo_title_applynow": "Apply Now | Apartments in Elk City, OK",
  "property_seo_description_applynow": "Lease your ideal home at Crestview Commons in Elk City, OK! Enjoy stylish living with modern finishes, a pool, and on-site maintenance. Apply online today!",
  "property_seo_title_residentaccess": "Resident Access | Crestview Commons",
  "property_seo_description_residentaccess": "Login to Crestview Commons! Manage your home effortlessly—pay rent, request maintenance, and connect with your community in Elk City, OK. Access now!",
  "property_seo_title_referafriend": "Refer A Friend | Crestview Commons",
  "property_seo_description_referafriend": "Refer a friend to Crestview Commons in Elk City, OK! Enjoy great neighbors and a vibrant community where friendships thrive. Join us today!",
  "property_seo_title_scheduletour": "Schedule a Tour | Crestview Commons",
  "property_seo_description_scheduletour": "Experience the charm of Crestview Commons in Elk City, OK. Schedule a tour today and find your perfect apartment home in our vibrant community!",
  "property_seo_title_privacy": "Privacy Policy | Crestview Commons",
  "property_seo_description_privacy": "At Crestview Commons, your privacy matters. Discover how we safeguard your personal info while you enjoy our welcoming community. View our policy!",
  "property_seo_title_accessibility": "Website Accessibility | Crestview Commons",
  "property_seo_description_accessibility": "At Crestview Commons in Elk City, OK, we champion digital inclusion. Our commitment to accessibility ensures everyone can enjoy our exceptional community.",
  "property_seo_title_sitemap": "Sitemap | Crestview Commons",
  "property_seo_description_sitemap": "Unlock a world of possibilities at Crestview Commons in Elk City, OK. Navigate our sitemap and find your perfect home today!",
  "property_seo_title_thankyou": "Thank You | Crestview Commons",
  "property_seo_description_thankyou": "Thank you for reaching out to Crestview Commons in Elk City! Our team will be in touch soon to help you find your perfect home in our vibrant community.",
  "property_seo_title_pets": "Pet Policy | Apartments in Elk City, OK",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1791293623517",
  "amenities": [
    {
      "id": "ec_d0c7b7eb0bfb0b014e0c6118",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166975",
      "source": "generator",
      "external_id": "false",
      "title": "Smoke‑Free",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_77d3da421d8a45eeb8439c6e",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166975",
      "source": "generator",
      "external_id": "false",
      "title": "Maintenance on Site",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b8aa35d3e3791ac4569ec1f4",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166975",
      "source": "generator",
      "external_id": "false",
      "title": "Pool",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_33f5456119205c36cdd283e0",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166975",
      "source": "generator",
      "external_id": "false",
      "title": "Laundry Facilities",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_5310a2b14455995decffbf0e",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166975",
      "source": "generator",
      "external_id": "false",
      "title": "Property Manager on Site",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_18aeafec0864e77981044e15",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166975",
      "source": "generator",
      "external_id": "false",
      "title": "9 Foot Ceilings",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_321a93eef6e37cd5a6d2cdcc",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166975",
      "source": "generator",
      "external_id": "false",
      "title": "Designer Selected Modern Finishes",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a6371ccd6488de6ac55b0f18",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166975",
      "source": "generator",
      "external_id": "false",
      "title": "Energy Efficient: A/C & Heat, Microwave Oven, Refrigerator, Dishwasher, Lighting, Windows",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e948625b455b41f3447c23c8",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166975",
      "source": "generator",
      "external_id": "false",
      "title": "Wood Plan Style Flooring",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a4fad9be9d7a052f859788bd",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166975",
      "source": "generator",
      "external_id": "false",
      "title": "Breakfast Bar",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4d365575dd7c80f9d48f7a26",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166975",
      "source": "generator",
      "external_id": "false",
      "title": "High‑Speed Internet & Cable Ready",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_efd1be3f-32e0-4e70-8908-dca3e12f8d46",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166975",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166975/019ea7e6-3e59-76e7-b78f-2077dd3bba0c.webp",
      "image_media": {
        "alt_text": "Empty living room with light gray walls and wood-look flooring.",
        "public_id": "019ea7e6-3e59-76e7-b78f-2077dd3bba0c",
        "storage_key": "property/6767906449166975/019ea7e6-3e59-76e7-b78f-2077dd3bba0c.webp",
        "width": 1500,
        "height": 1000
      },
      "title": "Apartment",
      "description": "Spacious living area with neutral finishes and an open view into the kitchen.",
      "link": "",
      "alt_text": "Empty living room with light gray walls and wood-look flooring.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_6e2a3e0b-4419-4ede-8531-60a9fe39348a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166975",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166975/019ea7e6-896a-706a-ad49-c47b51c2a75a.webp",
      "image_media": {
        "alt_text": "Apartment building exteriors with a paved parking lot and green spaces.",
        "public_id": "019ea7e6-896a-706a-ad49-c47b51c2a75a",
        "storage_key": "property/6767906449166975/019ea7e6-896a-706a-ad49-c47b51c2a75a.webp",
        "width": 1500,
        "height": 1000
      },
      "title": "Community",
      "description": "View of the exterior of apartment buildings, showcasing the community grounds and parking areas.",
      "link": "",
      "alt_text": "Apartment building exteriors with a paved parking lot and green spaces.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_087e045b-8adc-4779-9917-cc26c64c687c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166975",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166975/019ea7e6-79f3-7089-9f45-dfb37ee9c692.webp",
      "image_media": {
        "alt_text": "Laundry room with multiple washers and dryers.",
        "public_id": "019ea7e6-79f3-7089-9f45-dfb37ee9c692",
        "storage_key": "property/6767906449166975/019ea7e6-79f3-7089-9f45-dfb37ee9c692.webp",
        "width": 1500,
        "height": 999
      },
      "title": "Community",
      "description": "Convenient on-site laundry facilities with multiple washers and dryers for residents.",
      "link": "",
      "alt_text": "Laundry room with multiple washers and dryers.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_32e2143f-0205-40f1-83e9-f683bb5e56c1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166975",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166975/019ea7e6-56b9-724d-9003-4b7d5b4a0dd4.webp",
      "image_media": {
        "alt_text": "Living room with sliding glass door and air conditioning unit.",
        "public_id": "019ea7e6-56b9-724d-9003-4b7d5b4a0dd4",
        "storage_key": "property/6767906449166975/019ea7e6-56b9-724d-9003-4b7d5b4a0dd4.webp",
        "width": 1500,
        "height": 1000
      },
      "title": "Apartment",
      "description": "Spacious living area with plush carpeting and a wall-mounted air conditioning unit. Large sliding glass door provides natural light and access to the outdoors.",
      "link": "",
      "alt_text": "Living room with sliding glass door and air conditioning unit.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_f7a21d91-3cf7-44ab-9be8-6645511fe064",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166975",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166975/019ea7e6-8049-708e-b774-01e8eede8a8c.webp",
      "image_media": {
        "alt_text": "View of the apartment complex's exterior with a parking lot and leasing signs.",
        "public_id": "019ea7e6-8049-708e-b774-01e8eede8a8c",
        "storage_key": "property/6767906449166975/019ea7e6-8049-708e-b774-01e8eede8a8c.webp",
        "width": 1500,
        "height": 1000
      },
      "title": "Community",
      "description": "Explore the welcoming exterior of our community, featuring ample parking and visible leasing information to assist you.",
      "link": "",
      "alt_text": "View of the apartment complex's exterior with a parking lot and leasing signs.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_e38ec26e-f96a-4795-9eaa-390302ec6203",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166975",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166975/019ea7e6-5640-747a-8578-5200ebf4cf3d.webp",
      "image_media": {
        "alt_text": "Living room and kitchen area with carpet, wood-look floor, and air conditioning unit.",
        "public_id": "019ea7e6-5640-747a-8578-5200ebf4cf3d",
        "storage_key": "property/6767906449166975/019ea7e6-5640-747a-8578-5200ebf4cf3d.webp",
        "width": 1500,
        "height": 1000
      },
      "title": "Apartment",
      "description": "Spacious living area flows into a functional kitchen space, complete with essential appliances and ample counter space.",
      "link": "",
      "alt_text": "Living room and kitchen area with carpet, wood-look floor, and air conditioning unit.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_db5a732d-8495-4de8-88bb-aaa4a5f5ad15",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166975",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166975/019ea7e6-7092-76cd-b9a9-0f1d8f8e24aa.webp",
      "image_media": {
        "alt_text": "Laundry room with multiple rows of washing machines and dryers, along with a trash can and a fire extinguisher on the wall.",
        "public_id": "019ea7e6-7092-76cd-b9a9-0f1d8f8e24aa",
        "storage_key": "property/6767906449166975/019ea7e6-7092-76cd-b9a9-0f1d8f8e24aa.webp",
        "width": 1500,
        "height": 1000
      },
      "title": "Community",
      "description": "Convenient on-site laundry facilities make it easy to keep your clothes fresh and clean.",
      "link": "",
      "alt_text": "Laundry room with multiple rows of washing machines and dryers, along with a trash can and a fire extinguisher on the wall.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_b56a8d0e-4a52-4a45-8e42-12916ad094f2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166975",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166975/019ea7e6-487a-738b-9083-a5c0f5338793.webp",
      "image_media": {
        "alt_text": "Interior view of an unfurnished bedroom with neutral walls and carpet.",
        "public_id": "019ea7e6-487a-738b-9083-a5c0f5338793",
        "storage_key": "property/6767906449166975/019ea7e6-487a-738b-9083-a5c0f5338793.webp",
        "width": 1500,
        "height": 1000
      },
      "title": "Apartment",
      "description": "Spacious and unfurnished bedroom with neutral-toned walls and plush carpeting, ready for your personal touch.",
      "link": "",
      "alt_text": "Interior view of an unfurnished bedroom with neutral walls and carpet.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_791950c5-4417-4140-a559-8f6545cbdad7",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166975",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166975/019ea7e6-6a79-7493-a2eb-d26505640ef9.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment buildings with parking lot and trees.",
        "public_id": "019ea7e6-6a79-7493-a2eb-d26505640ef9",
        "storage_key": "property/6767906449166975/019ea7e6-6a79-7493-a2eb-d26505640ef9.webp",
        "width": 1500,
        "height": 1000
      },
      "title": "Community",
      "description": "Discover comfortable living with our apartment exteriors. Enjoy ample parking and green spaces for a pleasant community atmosphere.",
      "link": "",
      "alt_text": "Exterior view of apartment buildings with parking lot and trees.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_45802301-8189-4188-b4cf-632bff287432",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166975",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166975/019ea7e6-6d2a-743f-8e79-d8ed692630ef.webp",
      "image_media": {
        "alt_text": "Laundry room with rows of washing machines and dryers, seating area, and window view.",
        "public_id": "019ea7e6-6d2a-743f-8e79-d8ed692630ef",
        "storage_key": "property/6767906449166975/019ea7e6-6d2a-743f-8e79-d8ed692630ef.webp",
        "width": 1500,
        "height": 1000
      },
      "title": "Community",
      "description": "Convenient on-site laundry facilities equipped with multiple washers and dryers, offering a comfortable space for residents to manage their laundry needs.",
      "link": "",
      "alt_text": "Laundry room with rows of washing machines and dryers, seating area, and window view.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_8504775c-31a3-4a13-9853-a1ebfe71a3bb",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166975",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166975/019ea7e6-712f-776d-93de-8d0aed94ed08.webp",
      "image_media": {
        "alt_text": "Laundry room with rows of washers and dryers.",
        "public_id": "019ea7e6-712f-776d-93de-8d0aed94ed08",
        "storage_key": "property/6767906449166975/019ea7e6-712f-776d-93de-8d0aed94ed08.webp",
        "width": 1500,
        "height": 1000
      },
      "title": "Community",
      "description": "On-site laundry facilities equipped with multiple washers and dryers for resident convenience.",
      "link": "",
      "alt_text": "Laundry room with rows of washers and dryers.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_5a0d4397-5f5c-4d73-91ee-75ca324d8e10",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166975",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166975/019ea7e6-6ae9-71ba-b75a-fec8694552e6.webp",
      "image_media": {
        "alt_text": "Laundry room with rows of washing machines and dryers.",
        "public_id": "019ea7e6-6ae9-71ba-b75a-fec8694552e6",
        "storage_key": "property/6767906449166975/019ea7e6-6ae9-71ba-b75a-fec8694552e6.webp",
        "width": 1500,
        "height": 1000
      },
      "title": "Community",
      "description": "Convenient on-site laundry facilities equipped with multiple washing machines and dryers for resident use.",
      "link": "",
      "alt_text": "Laundry room with rows of washing machines and dryers.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_f7342780-ede7-4903-bdfb-b6ce13b66e37",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166975",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166975/019ea7e6-5573-76f0-918d-8baca48fa692.webp",
      "image_media": {
        "alt_text": "Kitchen area with white appliances, double sink, and wood cabinets.",
        "public_id": "019ea7e6-5573-76f0-918d-8baca48fa692",
        "storage_key": "property/6767906449166975/019ea7e6-5573-76f0-918d-8baca48fa692.webp",
        "width": 1500,
        "height": 1000
      },
      "title": "Apartment",
      "description": "Bright kitchen featuring a full-size refrigerator, stove, oven, and a double sink with ample counter space. The space includes warm wood cabinetry and a clean, modern aesthetic.",
      "link": "",
      "alt_text": "Kitchen area with white appliances, double sink, and wood cabinets.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_0b93076c-e286-4ae7-8c28-ad33f7d6fe98",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166975",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166975/019ea7e6-616d-766d-8ef9-f508f6a4742c.webp",
      "image_media": {
        "alt_text": "Mailroom with rows of mailboxes on both sides of a hallway.",
        "public_id": "019ea7e6-616d-766d-8ef9-f508f6a4742c",
        "storage_key": "property/6767906449166975/019ea7e6-616d-766d-8ef9-f508f6a4742c.webp",
        "width": 1500,
        "height": 1000
      },
      "title": "Community",
      "description": "Secure mailroom with multiple rows of mailboxes conveniently located for residents.",
      "link": "",
      "alt_text": "Mailroom with rows of mailboxes on both sides of a hallway.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_382a65f9-5c59-4875-b0b1-a49740685378",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166975",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166975/019ea7e6-5f32-711d-b37f-a8e321af5989.webp",
      "image_media": {
        "alt_text": "Mailboxes in hallway with doors and a rent drop slot.",
        "public_id": "019ea7e6-5f32-711d-b37f-a8e321af5989",
        "storage_key": "property/6767906449166975/019ea7e6-5f32-711d-b37f-a8e321af5989.webp",
        "width": 1500,
        "height": 1000
      },
      "title": "Community",
      "description": "Secure mailboxes line the hallway, offering residents a convenient place to receive mail. A rent drop slot is also available for easy payments.",
      "link": "",
      "alt_text": "Mailboxes in hallway with doors and a rent drop slot.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_da368fa8-5452-44cc-83fc-288c7905980b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166975",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166975/019ea7e6-5b0f-7476-8f96-68f0cb6379e3.webp",
      "image_media": {
        "alt_text": "Exterior apartment building entrance with a green door numbered 10 and an air conditioning unit.",
        "public_id": "019ea7e6-5b0f-7476-8f96-68f0cb6379e3",
        "storage_key": "property/6767906449166975/019ea7e6-5b0f-7476-8f96-68f0cb6379e3.webp",
        "width": 1500,
        "height": 1000
      },
      "title": "Community",
      "description": "View of an exterior apartment building entrance, featuring a green door with the number 10, an outdoor air conditioning unit, and a railing leading down to the parking area.",
      "link": "",
      "alt_text": "Exterior apartment building entrance with a green door numbered 10 and an air conditioning unit.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_bdf60906-c9bc-48a7-99d9-8637280f2aa0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166975",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166975/019ea7e6-4548-757f-8fd8-262fd32fe8d1.webp",
      "image_media": {
        "alt_text": "Empty living room with sliding glass door and light grey walls.",
        "public_id": "019ea7e6-4548-757f-8fd8-262fd32fe8d1",
        "storage_key": "property/6767906449166975/019ea7e6-4548-757f-8fd8-262fd32fe8d1.webp",
        "width": 1500,
        "height": 1000
      },
      "title": "Apartment",
      "description": "Spacious living area with modern wood-look flooring and a sliding glass door leading to the outdoors. Light grey walls create a neutral and airy atmosphere.",
      "link": "",
      "alt_text": "Empty living room with sliding glass door and light grey walls.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_7be3627b-b811-4ea4-9024-91e1609a7ce7",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166975",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166975/019ea7e6-4c6e-73f2-8cc9-ec1e321c7afc.webp",
      "image_media": {
        "alt_text": "Empty bedroom with wood-look flooring and access to bathroom and closet.",
        "public_id": "019ea7e6-4c6e-73f2-8cc9-ec1e321c7afc",
        "storage_key": "property/6767906449166975/019ea7e6-4c6e-73f2-8cc9-ec1e321c7afc.webp",
        "width": 1500,
        "height": 1000
      },
      "title": "Apartment",
      "description": "Spacious bedroom with ample closet space and easy access to the bathroom. This room features modern wood-look flooring and neutral gray walls.",
      "link": "",
      "alt_text": "Empty bedroom with wood-look flooring and access to bathroom and closet.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_936cf6d7-7bce-4747-8b71-0c003c657420",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166975",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166975/019ea7e6-3721-75a9-ba34-164be67e887a.webp",
      "image_media": {
        "alt_text": "Bedroom with wood-look flooring and a view into the bathroom.",
        "public_id": "019ea7e6-3721-75a9-ba34-164be67e887a",
        "storage_key": "property/6767906449166975/019ea7e6-3721-75a9-ba34-164be67e887a.webp",
        "width": 1500,
        "height": 1000
      },
      "title": "Apartment",
      "description": "Bright and airy bedroom featuring wood-look laminate flooring and neutral gray walls. Enjoy the convenience of an en-suite bathroom.",
      "link": "",
      "alt_text": "Bedroom with wood-look flooring and a view into the bathroom.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_b71b92f1-866c-49da-bf45-6dbf402c166c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166975",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166975/019ea7e6-4b9e-748b-be3a-957a7c831226.webp",
      "image_media": {
        "alt_text": "Empty bedroom with beige walls, carpet, and a single window with blinds.",
        "public_id": "019ea7e6-4b9e-748b-be3a-957a7c831226",
        "storage_key": "property/6767906449166975/019ea7e6-4b9e-748b-be3a-957a7c831226.webp",
        "width": 1500,
        "height": 1000
      },
      "title": "Apartment",
      "description": "A spacious bedroom with neutral tones, carpet flooring, and a window, ready for your personal touch.",
      "link": "",
      "alt_text": "Empty bedroom with beige walls, carpet, and a single window with blinds.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_ab432d21-5806-4e21-abce-4068ac8ecf5e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166975",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166975/019ea7e6-477b-758c-abdb-c5c374a679bf.webp",
      "image_media": {
        "alt_text": "Empty bedroom with beige walls and carpet, interior view showing a doorway to a bathroom.",
        "public_id": "019ea7e6-477b-758c-abdb-c5c374a679bf",
        "storage_key": "property/6767906449166975/019ea7e6-477b-758c-abdb-c5c374a679bf.webp",
        "width": 1500,
        "height": 1000
      },
      "title": "Apartment",
      "description": "Spacious bedroom with plush carpeting and neutral paint. A doorway provides a glimpse into the adjacent bathroom, offering a functional and comfortable living space.",
      "link": "",
      "alt_text": "Empty bedroom with beige walls and carpet, interior view showing a doorway to a bathroom.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_24ee4ad2-fe97-4de0-b75a-5b0fdd27adea",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166975",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166975/019ea7e6-4668-70fa-9f97-c70ca928c09a.webp",
      "image_media": {
        "alt_text": "Exterior entrance to apartment building with stairs and door number 76.",
        "public_id": "019ea7e6-4668-70fa-9f97-c70ca928c09a",
        "storage_key": "property/6767906449166975/019ea7e6-4668-70fa-9f97-c70ca928c09a.webp",
        "width": 1500,
        "height": 1000
      },
      "title": "Community",
      "description": "Exterior view of an apartment building entrance. Features a staircase, siding, and a brick accent wall.",
      "link": "",
      "alt_text": "Exterior entrance to apartment building with stairs and door number 76.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_a0c80407-623c-4083-a9a4-efe138387c7a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166975",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166975/019ea7e6-45e3-7728-9d17-43412faf99fb.webp",
      "image_media": {
        "alt_text": "View from balcony overlooking parking lot and outdoor pool.",
        "public_id": "019ea7e6-45e3-7728-9d17-43412faf99fb",
        "storage_key": "property/6767906449166975/019ea7e6-45e3-7728-9d17-43412faf99fb.webp",
        "width": 1500,
        "height": 1000
      },
      "title": "Community",
      "description": "Enjoy the view from your private balcony, overlooking the community's outdoor swimming pool and surrounding grounds.",
      "link": "",
      "alt_text": "View from balcony overlooking parking lot and outdoor pool.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_c375ec21-5ee4-483e-bcf3-7beb701a86fb",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166975",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166975/019ea7e6-34ee-71de-8d06-630ac0f7993a.webp",
      "image_media": {
        "alt_text": "Bathroom with white tub, toilet, and vanity with sink and mirror.",
        "public_id": "019ea7e6-34ee-71de-8d06-630ac0f7993a",
        "storage_key": "property/6767906449166975/019ea7e6-34ee-71de-8d06-630ac0f7993a.webp",
        "width": 1500,
        "height": 1002
      },
      "title": "Apartment",
      "description": "Clean and functional bathroom featuring a white bathtub, toilet, and a vanity with a sink and mirror.",
      "link": "",
      "alt_text": "Bathroom with white tub, toilet, and vanity with sink and mirror.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_6c4e5f1a-32b4-48a0-8ed1-65f53e6d0e4f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166975",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166975/019ea7e6-368f-77c2-bd54-d5a5937c6b02.webp",
      "image_media": {
        "alt_text": "View of an empty apartment living room with a pass-through to the kitchen.",
        "public_id": "019ea7e6-368f-77c2-bd54-d5a5937c6b02",
        "storage_key": "property/6767906449166975/019ea7e6-368f-77c2-bd54-d5a5937c6b02.webp",
        "width": 1500,
        "height": 999
      },
      "title": "Apartment",
      "description": "Spacious living area in an apartment, featuring wood-look flooring and a pass-through window to the kitchen.",
      "link": "",
      "alt_text": "View of an empty apartment living room with a pass-through to the kitchen.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_16d78c2f-c8da-4675-9d9a-bd3673684399",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166975",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166975/019ea7e6-3754-7138-a1b3-8f8a402da630.webp",
      "image_media": {
        "alt_text": "Kitchen with refrigerator, cabinets, sink, and dishwasher",
        "public_id": "019ea7e6-3754-7138-a1b3-8f8a402da630",
        "storage_key": "property/6767906449166975/019ea7e6-3754-7138-a1b3-8f8a402da630.webp",
        "width": 1500,
        "height": 1000
      },
      "title": "Apartment",
      "description": "View of a kitchen featuring white appliances, ample cabinet storage, a double sink, and a granite-style countertop. An opening looks into the adjacent living area.",
      "link": "",
      "alt_text": "Kitchen with refrigerator, cabinets, sink, and dishwasher",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_984a6b1f-3ba0-4330-afd4-7c81ad241a02",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166975",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166975/019ea7e6-34e5-74b9-ad5f-3886d77528b1.webp",
      "image_media": {
        "alt_text": "Bathroom with a vanity, sink, toilet, and bathtub with shower.",
        "public_id": "019ea7e6-34e5-74b9-ad5f-3886d77528b1",
        "storage_key": "property/6767906449166975/019ea7e6-34e5-74b9-ad5f-3886d77528b1.webp",
        "width": 1500,
        "height": 1000
      },
      "title": "Apartment",
      "description": "This bathroom features a vanity with a sink and ample storage, a toilet, and a bathtub with a shower for your convenience.",
      "link": "",
      "alt_text": "Bathroom with a vanity, sink, toilet, and bathtub with shower.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_0e11d500-2452-47f9-93c7-27f9d638c01c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166975",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166975/019ea7e6-34f0-70cd-baa5-236c786667ea.webp",
      "image_media": {
        "alt_text": "Kitchenette with white refrigerator, double sink, and wooden cabinets.",
        "public_id": "019ea7e6-34f0-70cd-baa5-236c786667ea",
        "storage_key": "property/6767906449166975/019ea7e6-34f0-70cd-baa5-236c786667ea.webp",
        "width": 1500,
        "height": 1001
      },
      "title": "Apartment",
      "description": "A compact kitchenette featuring a white refrigerator, a double sink, and ample wooden cabinetry, perfect for efficient living.",
      "link": "",
      "alt_text": "Kitchenette with white refrigerator, double sink, and wooden cabinets.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_ff414a66-d400-43b1-9e7a-c71dda7ec7f0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166975",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166975/019ea7e6-34c3-7058-9934-0b853af9ee4b.webp",
      "image_media": {
        "alt_text": "Kitchen with stove and sink, view down hallway to living area",
        "public_id": "019ea7e6-34c3-7058-9934-0b853af9ee4b",
        "storage_key": "property/6767906449166975/019ea7e6-34c3-7058-9934-0b853af9ee4b.webp",
        "width": 1500,
        "height": 1002
      },
      "title": "Apartment",
      "description": "View of the kitchen area featuring a stove and sink, with a hallway leading to the living space.",
      "link": "",
      "alt_text": "Kitchen with stove and sink, view down hallway to living area",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_150437bb-f78c-4864-ba6f-c1bf1cf62bd7",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166975",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166975/019ea7e6-3768-76b9-8db6-11cdf70753a2.webp",
      "image_media": {
        "alt_text": "Empty bedroom with blinds on window and light gray walls.",
        "public_id": "019ea7e6-3768-76b9-8db6-11cdf70753a2",
        "storage_key": "property/6767906449166975/019ea7e6-3768-76b9-8db6-11cdf70753a2.webp",
        "width": 1500,
        "height": 1000
      },
      "title": "Apartment",
      "description": "Spacious bedroom with light gray walls, wood-style flooring, and a large window with blinds.",
      "link": "",
      "alt_text": "Empty bedroom with blinds on window and light gray walls.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_b729207a-e7e8-47f4-808e-48b4c7234e0c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166975",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166975/019ea7e6-34a7-747f-9706-5f59b2dbec78.webp",
      "image_media": {
        "alt_text": "Bathroom with vanity, toilet, and bathtub/shower combo.",
        "public_id": "019ea7e6-34a7-747f-9706-5f59b2dbec78",
        "storage_key": "property/6767906449166975/019ea7e6-34a7-747f-9706-5f59b2dbec78.webp",
        "width": 1500,
        "height": 999
      },
      "title": "Apartment",
      "description": "A clean and functional bathroom featuring a vanity with a marbled countertop, a toilet, and a bathtub with a showerhead.",
      "link": "",
      "alt_text": "Bathroom with vanity, toilet, and bathtub/shower combo.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_c921b26f-e9a5-438f-9a34-e1494759e9d3",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166975",
      "source": "custom",
      "poi_name": "Main Street Coffee & Cafe",
      "poi_type": "Restaurants",
      "poi_address": "101 N Main St, Elk City, OK 73644, USA",
      "poi_short_description": "Relaxed coffeehouse offering breakfast, panini, and desserts such as muffins.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166975/019d08b5-6dea-740b-8435-11ac32da8ed9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b5-6dea-740b-8435-11ac32da8ed9",
        "storage_key": "property/6767906449166975/019d08b5-6dea-740b-8435-11ac32da8ed9.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=10435893153750745973&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "main-street-coffee--cafe",
      "poi_latitude": "35.4108531",
      "poi_longitude": "-99.4051373",
      "poi_miles_from_property": "2.2",
      "poi_walking_minutes": "48 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 580-339-8252",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166975/019d08b5-e668-702d-b3c6-c43877b8a7e8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b5-e668-702d-b3c6-c43877b8a7e8",
        "storage_key": "property/6767906449166975/019d08b5-e668-702d-b3c6-c43877b8a7e8.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJB3kPFATlq4cRdYM-F4i905A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "coffee_shop"
    },
    {
      "id": "custom_0aeaec28-21e1-4f22-ad0f-ec4191e61f54",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166975",
      "source": "custom",
      "poi_name": "Eye Opener Coffee & Smoothie House",
      "poi_type": "Restaurants",
      "poi_address": "920 N Main St, Elk City, OK 73644, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166975/019d08b5-6da2-770a-89b4-30716e0b3ccc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b5-6da2-770a-89b4-30716e0b3ccc",
        "storage_key": "property/6767906449166975/019d08b5-6da2-770a-89b4-30716e0b3ccc.webp",
        "width": 1008,
        "height": 756
      },
      "poi_business_url": "http://eyeopenercoffee.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14763122383082018315&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "eye-opener-coffee--smoothie-house",
      "poi_latitude": "35.419042",
      "poi_longitude": "-99.4045261",
      "poi_miles_from_property": "1.9",
      "poi_walking_minutes": "40 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 580-339-6818",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166975/019d08b5-e668-702d-b3c6-c43877b8a7e8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b5-e668-702d-b3c6-c43877b8a7e8",
        "storage_key": "property/6767906449166975/019d08b5-e668-702d-b3c6-c43877b8a7e8.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJ4fAir5Tlq4cRC9Y4y5Yl4cw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "coffee_shop"
    },
    {
      "id": "custom_4e570f44-1a30-4b24-bb12-257932eee8d6",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166975",
      "source": "custom",
      "poi_name": "Scooter's Coffee",
      "poi_type": "Restaurants",
      "poi_address": "511 W 3rd St, Elk City, OK 73644, USA",
      "poi_short_description": "Drive-thru chain serving espresso & other coffee drinks, plus a variety of smoothies & pastries.",
      "poi_long_description": "Drive-thru chain serving espresso & other coffee drinks, plus a variety of smoothies & pastries.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166975/019d08b5-6d87-76ee-80de-6aca9a23ce54.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b5-6d87-76ee-80de-6aca9a23ce54",
        "storage_key": "property/6767906449166975/019d08b5-6d87-76ee-80de-6aca9a23ce54.webp",
        "width": 960,
        "height": 720
      },
      "poi_business_url": "https://scooterscoffee.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17232234720476405773&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "scooters-coffee",
      "poi_latitude": "35.4119339",
      "poi_longitude": "-99.4104561",
      "poi_miles_from_property": "1.8",
      "poi_walking_minutes": "40 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 877-719-1288",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166975/019d08b5-e668-702d-b3c6-c43877b8a7e8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b5-e668-702d-b3c6-c43877b8a7e8",
        "storage_key": "property/6767906449166975/019d08b5-e668-702d-b3c6-c43877b8a7e8.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJm6jNaejlq4cRDSAmkC0yJe8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "coffee_shop"
    },
    {
      "id": "custom_fe84e4c9-8ddc-4c56-a66e-3e0d3c45a9ec",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166975",
      "source": "custom",
      "poi_name": "Cafe Elk City",
      "poi_type": "Restaurants",
      "poi_address": "107 W 5th St, Elk City, OK 73644, USA",
      "poi_short_description": "Lunchtime spot serving sandwiches and desserts in a cozy setting.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166975/019d08b5-6ef2-72cf-b466-3f19d1d40362.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b5-6ef2-72cf-b466-3f19d1d40362",
        "storage_key": "property/6767906449166975/019d08b5-6ef2-72cf-b466-3f19d1d40362.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=8174948732262257918&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cafe-elk-city",
      "poi_latitude": "35.4098178",
      "poi_longitude": "-99.4053645",
      "poi_miles_from_property": "2.3",
      "poi_walking_minutes": "49 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 580-243-0801",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166975/019d08b5-e666-73ef-865e-b085f9a8f5dc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b5-e666-73ef-865e-b085f9a8f5dc",
        "storage_key": "property/6767906449166975/019d08b5-e666-73ef-865e-b085f9a8f5dc.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJLdruNgTlq4cR_pSFK49Ac3E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sandwich_shop"
    },
    {
      "id": "custom_6a00b0af-8564-48d7-bed4-303e6a46373b",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166975",
      "source": "custom",
      "poi_name": "Prairiefire Grille",
      "poi_type": "Restaurants",
      "poi_address": "422 S Main St, Elk City, OK 73644, USA",
      "poi_short_description": "Comfortable locale with a full bar serving steaks, salmon, chicken, and more comfort fare.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166975/019d08b5-7453-775d-9c75-34ce23f3e940.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b5-7453-775d-9c75-34ce23f3e940",
        "storage_key": "property/6767906449166975/019d08b5-7453-775d-9c75-34ce23f3e940.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.prairiefireelkcity.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17175262653143664209&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "prairiefire-grille",
      "poi_latitude": "35.4063759",
      "poi_longitude": "-99.4045562",
      "poi_miles_from_property": "2.5",
      "poi_walking_minutes": "55 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 580-225-6865",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166975/019d08b5-e5d6-741d-8ef8-efc8c995f3ee.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b5-e5d6-741d-8ef8-efc8c995f3ee",
        "storage_key": "property/6767906449166975/019d08b5-e5d6-741d-8ef8-efc8c995f3ee.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJZ1aO8gXlq4cRUUapdGLKWu4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bar_and_grill"
    },
    {
      "id": "custom_291a5f47-fbd6-4ee6-a299-ba977df25f49",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166975",
      "source": "custom",
      "poi_name": "Fred's Steakhouse",
      "poi_type": "Restaurants",
      "poi_address": "2107 S Main St, Elk City, OK 73644, USA",
      "poi_short_description": "Casual steakhouse featuring steaks and chicken-fried steak plus salads and desserts.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166975/019d08b5-743c-73c8-b07d-f8205b79909b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b5-743c-73c8-b07d-f8205b79909b",
        "storage_key": "property/6767906449166975/019d08b5-743c-73c8-b07d-f8205b79909b.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.fredssteakhouseok.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18151492439674936462&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "freds-steakhouse",
      "poi_latitude": "35.3902897",
      "poi_longitude": "-99.4050825",
      "poi_miles_from_property": "3.6",
      "poi_walking_minutes": "1 hour 19 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 580-243-2100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166975/019d08b5-e666-73ef-865e-b085f9a8f5dc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b5-e666-73ef-865e-b085f9a8f5dc",
        "storage_key": "property/6767906449166975/019d08b5-e666-73ef-865e-b085f9a8f5dc.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJtxhbLPXlq4cRjlwDAjQO5_s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "steak_house"
    },
    {
      "id": "custom_472deb67-df0c-4ff5-b899-5d185b7f2743",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166975",
      "source": "custom",
      "poi_name": "Osaki Steak & Sushi House",
      "poi_type": "Restaurants",
      "poi_address": "103 Janets Way, Elk City, OK 73644, USA",
      "poi_short_description": "Casual restaurant serving a wide variety of sushi rolls and hibachi fare, plus beer and sake.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166975/019d08b5-7582-736c-8d93-3db150c0bc57.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b5-7582-736c-8d93-3db150c0bc57",
        "storage_key": "property/6767906449166975/019d08b5-7582-736c-8d93-3db150c0bc57.webp",
        "width": 1280,
        "height": 622
      },
      "poi_business_url": "https://osakisteaksushi.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1317898924591069142&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "osaki-steak--sushi-house",
      "poi_latitude": "35.4107494",
      "poi_longitude": "-99.4397121",
      "poi_miles_from_property": "1.2",
      "poi_walking_minutes": "26 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 580-303-4927",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166975/019d08b5-e666-73ef-865e-b085f9a8f5dc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b5-e666-73ef-865e-b085f9a8f5dc",
        "storage_key": "property/6767906449166975/019d08b5-e666-73ef-865e-b085f9a8f5dc.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJdz9adMzlq4cR1rce4hYeShI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sushi_restaurant"
    },
    {
      "id": "custom_0fabcd7f-c323-4010-a614-06322d4be783",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166975",
      "source": "custom",
      "poi_name": "RibCrib BBQ",
      "poi_type": "Restaurants",
      "poi_address": "104 Regional Dr, Elk City, OK 73644, USA",
      "poi_short_description": "Barbecue chain dishing up ribs, brisket, sandwiches & sides in a laid-back setting.",
      "poi_long_description": "Barbecue chain dishing up ribs, brisket, sandwiches & sides in a laid-back setting.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166975/019d08b5-7591-76f9-9ebb-058abd8ee558.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b5-7591-76f9-9ebb-058abd8ee558",
        "storage_key": "property/6767906449166975/019d08b5-7591-76f9-9ebb-058abd8ee558.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://ribcrib.com/locations",
      "poi_directions_map_url": "https://maps.google.com/?cid=10757003973140074241&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ribcrib-bbq",
      "poi_latitude": "35.408051",
      "poi_longitude": "-99.3787993",
      "poi_miles_from_property": "4.1",
      "poi_walking_minutes": "1 hour 29 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 580-303-4607",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166975/019d08b5-e666-73ef-865e-b085f9a8f5dc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b5-e666-73ef-865e-b085f9a8f5dc",
        "storage_key": "property/6767906449166975/019d08b5-e666-73ef-865e-b085f9a8f5dc.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJPdvprjrlq4cRAc962h6OSJU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "barbecue_restaurant"
    },
    {
      "id": "custom_4b7d8e43-a544-412e-a8e1-a6274b78b52a",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166975",
      "source": "custom",
      "poi_name": "Huddle House",
      "poi_type": "Restaurants",
      "poi_address": "103 Regional Dr, Elk City, OK 73644, USA",
      "poi_short_description": "Diner-style restaurant serving up breakfast and American fare in a relaxed setting.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166975/019d08b5-7bc4-74fb-9ee4-8dbfd8812ec7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b5-7bc4-74fb-9ee4-8dbfd8812ec7",
        "storage_key": "property/6767906449166975/019d08b5-7bc4-74fb-9ee4-8dbfd8812ec7.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://huddlehouse.com/locations/ok/elk-city/103-regional-dr",
      "poi_directions_map_url": "https://maps.google.com/?cid=8851458752709510619&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "huddle-house",
      "poi_latitude": "35.4084214",
      "poi_longitude": "-99.379689",
      "poi_miles_from_property": "4",
      "poi_walking_minutes": "1 hour 29 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 580-303-4505",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166975/019d08b5-e666-73ef-865e-b085f9a8f5dc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b5-e666-73ef-865e-b085f9a8f5dc",
        "storage_key": "property/6767906449166975/019d08b5-e666-73ef-865e-b085f9a8f5dc.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJQyrTiQPlq4cR28VFq9ay1no",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_26426566-292e-4b2a-afc4-2c51e5c1d748",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166975",
      "source": "custom",
      "poi_name": "Pizza Hut",
      "poi_type": "Restaurants",
      "poi_address": "1120 W 3rd St, Elk City, OK 73644, USA",
      "poi_short_description": "Popular delivery, carry-out & dine-in chain known for pizza, wings & pasta, plus sides & desserts.",
      "poi_long_description": "Popular delivery, carry-out & dine-in chain known for pizza, wings & pasta, plus sides & desserts.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166975/019d08b5-7ae9-7248-8d8c-14ae800d0800.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b5-7ae9-7248-8d8c-14ae800d0800",
        "storage_key": "property/6767906449166975/019d08b5-7ae9-7248-8d8c-14ae800d0800.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://locations.pizzahut.com/ok/elk-city/1120-w-3rd-st?utm_medium=organic&utm_source=local&utm_campaign=googlelistings&utm_content=website&utm_term=283636",
      "poi_directions_map_url": "https://maps.google.com/?cid=7734630930614462126&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pizza-hut",
      "poi_latitude": "35.4113648",
      "poi_longitude": "-99.4178045",
      "poi_miles_from_property": "1.5",
      "poi_walking_minutes": "32 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 580-225-1160",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166975/019d08b5-e667-73ac-9fec-ff53f91b1d73.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b5-e667-73ac-9fec-ff53f91b1d73",
        "storage_key": "property/6767906449166975/019d08b5-e667-73ac-9fec-ff53f91b1d73.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJwWDbEKzlq4cRriYGANrtVms",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "meal_delivery"
    },
    {
      "id": "custom_7905886c-66d7-417e-8cf4-eb8bb50d04a3",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166975",
      "source": "custom",
      "poi_name": "Domino's Pizza",
      "poi_type": "Restaurants",
      "poi_address": "1029 W 3rd St, Elk City, OK 73644, USA",
      "poi_short_description": "Delivery/carryout chain offering a wide range of pizzas & a variety of other dishes & sides.",
      "poi_long_description": "Delivery/carryout chain offering a wide range of pizzas & a variety of other dishes & sides.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166975/019d08b5-7ccb-7773-999f-8799c4cc063c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b5-7ccb-7773-999f-8799c4cc063c",
        "storage_key": "property/6767906449166975/019d08b5-7ccb-7773-999f-8799c4cc063c.webp",
        "width": 640,
        "height": 480
      },
      "poi_business_url": "http://www.dominos.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4822528213851314506&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dominos-pizza",
      "poi_latitude": "35.4120919",
      "poi_longitude": "-99.4168919",
      "poi_miles_from_property": "1.5",
      "poi_walking_minutes": "32 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 580-303-7888",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166975/019d08b5-e667-73ac-9fec-ff53f91b1d73.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b5-e667-73ac-9fec-ff53f91b1d73",
        "storage_key": "property/6767906449166975/019d08b5-e667-73ac-9fec-ff53f91b1d73.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJhUVP8qvlq4cRShnoEdwP7UI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "meal_delivery"
    },
    {
      "id": "custom_2c3bb83e-ae39-4d3f-ad8f-8241b7447ebb",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166975",
      "source": "custom",
      "poi_name": "Lupes Mexican restaurant",
      "poi_type": "Restaurants",
      "poi_address": "905 N Main St, Elk City, OK 73644, USA",
      "poi_short_description": "Chilled salsa, hot plates and friendly service at a traditional Mexican restaurant featuring a variety of meals.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166975/019d08b5-7d62-7683-b28d-ee63b1bc3ad5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b5-7d62-7683-b28d-ee63b1bc3ad5",
        "storage_key": "property/6767906449166975/019d08b5-7d62-7683-b28d-ee63b1bc3ad5.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=4756226892613525272&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lupes-mexican-restaurant",
      "poi_latitude": "35.41871",
      "poi_longitude": "-99.4051525",
      "poi_miles_from_property": "1.9",
      "poi_walking_minutes": "41 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 580-225-7109",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166975/019d08b5-e666-73ef-865e-b085f9a8f5dc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b5-e666-73ef-865e-b085f9a8f5dc",
        "storage_key": "property/6767906449166975/019d08b5-e666-73ef-865e-b085f9a8f5dc.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJiSi87knlq4cRGJ9jxSiDAUI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "custom_0ba9f33c-12a0-4a4c-9e69-b46faa521e03",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166975",
      "source": "custom",
      "poi_name": "Pedro's Mexican Food",
      "poi_type": "Restaurants",
      "poi_address": "902 S Main St, Elk City, OK 73644, USA",
      "poi_short_description": "Mexican spot serving enchiladas, tacos, fajitas and steaks amid colorful surroundings.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166975/019d08b5-82a3-76f4-8e8b-8e8da81d839f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b5-82a3-76f4-8e8b-8e8da81d839f",
        "storage_key": "property/6767906449166975/019d08b5-82a3-76f4-8e8b-8e8da81d839f.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=11373568779653092642&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pedros-mexican-food",
      "poi_latitude": "35.4015389",
      "poi_longitude": "-99.4045619",
      "poi_miles_from_property": "2.9",
      "poi_walking_minutes": "1 hour 2 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 580-225-3644",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166975/019d08b5-e666-73ef-865e-b085f9a8f5dc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b5-e666-73ef-865e-b085f9a8f5dc",
        "storage_key": "property/6767906449166975/019d08b5-e666-73ef-865e-b085f9a8f5dc.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJa-6EjbPlq4cRIhWym4sI150",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "custom_7bfbc6ec-0cfc-4d7e-9c10-235d3f2e8cda",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166975",
      "source": "custom",
      "poi_name": "United Supermarkets",
      "poi_type": "Shopping & Retail",
      "poi_address": "2700 W 3rd St, Elk City, OK 73644, USA",
      "poi_short_description": "Grocery chain offering fresh produce, meats, and other staples, plus a deli.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166975/019d08b5-8539-766a-9ee7-05b97784f400.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b5-8539-766a-9ee7-05b97784f400",
        "storage_key": "property/6767906449166975/019d08b5-8539-766a-9ee7-05b97784f400.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.unitedok.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8335024647888070576&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "united-supermarkets",
      "poi_latitude": "35.4104806",
      "poi_longitude": "-99.4360301",
      "poi_miles_from_property": "1",
      "poi_walking_minutes": "22 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 580-225-2288",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166975/019d08b5-eada-765f-a6f6-bfb3022ecc3d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b5-eada-765f-a6f6-bfb3022ecc3d",
        "storage_key": "property/6767906449166975/019d08b5-eada-765f-a6f6-bfb3022ecc3d.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ15g_Usrlq4cRsGd-o8H0q3M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_f73f973a-83b3-4002-b794-96435f14a0e2",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166975",
      "source": "custom",
      "poi_name": "Dollar General",
      "poi_type": "Shopping & Retail",
      "poi_address": "2704 W 3rd St, Elk City, OK 73644, USA",
      "poi_short_description": "Bargain retail chain selling a range of household goods, groceries, beauty products & more.",
      "poi_long_description": "Bargain retail chain selling a range of household goods, groceries, beauty products & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166975/019d08b5-8c58-727c-b7fc-e4e94a55c108.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b5-8c58-727c-b7fc-e4e94a55c108",
        "storage_key": "property/6767906449166975/019d08b5-8c58-727c-b7fc-e4e94a55c108.webp",
        "width": 480,
        "height": 720
      },
      "poi_business_url": "https://www.dollargeneral.com/store-directory/ok/elk-city/3239",
      "poi_directions_map_url": "https://maps.google.com/?cid=232522084351693101&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dollar-general",
      "poi_latitude": "35.4105339",
      "poi_longitude": "-99.4366683",
      "poi_miles_from_property": "1",
      "poi_walking_minutes": "23 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 405-839-7370",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166975/019d08b5-eb62-75ad-bc25-2251dff31570.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b5-eb62-75ad-bc25-2251dff31570",
        "storage_key": "property/6767906449166975/019d08b5-eb62-75ad-bc25-2251dff31570.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJyy-nmMvlq4cRLVE3kJoVOgM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "discount_store"
    },
    {
      "id": "custom_49bcb1e3-55d4-41c8-9d3a-43e997bf450c",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166975",
      "source": "custom",
      "poi_name": "Family Dollar",
      "poi_type": "Shopping & Retail",
      "poi_address": "3005 W 3rd St, Elk City, OK 73644, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166975/019d08b5-8cd9-72d4-a358-c0c988177c6c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b5-8cd9-72d4-a358-c0c988177c6c",
        "storage_key": "property/6767906449166975/019d08b5-8cd9-72d4-a358-c0c988177c6c.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://locations.familydollar.com/ok/elk-city/3005-w-3rd?utm_source=google&utm_medium=organic&utm_campaign=maps",
      "poi_directions_map_url": "https://maps.google.com/?cid=8010885970593462857&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "family-dollar",
      "poi_latitude": "35.4127494",
      "poi_longitude": "-99.4431854",
      "poi_miles_from_property": "1.3",
      "poi_walking_minutes": "30 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 580-303-4393",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166975/019d08b5-eb62-75ad-bc25-2251dff31570.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b5-eb62-75ad-bc25-2251dff31570",
        "storage_key": "property/6767906449166975/019d08b5-eb62-75ad-bc25-2251dff31570.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJgzD9VMflq4cRSTpixVhiLG8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "discount_store"
    },
    {
      "id": "custom_d7b22c5e-cfb2-419e-8060-7764a0353150",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166975",
      "source": "custom",
      "poi_name": "Tractor Supply Co.",
      "poi_type": "Shopping & Retail",
      "poi_address": "3105 W 3rd St Ste 100, Elk City, OK 73644, USA",
      "poi_short_description": "Chain with a wide variety of agricultural & livestock supplies, plus tools, workwear & boots.",
      "poi_long_description": "Chain with a wide variety of agricultural & livestock supplies, plus tools, workwear & boots.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166975/019d08b5-9266-761a-a25b-419565485a18.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b5-9266-761a-a25b-419565485a18",
        "storage_key": "property/6767906449166975/019d08b5-9266-761a-a25b-419565485a18.webp",
        "width": 1200,
        "height": 900
      },
      "poi_business_url": "https://www.tractorsupply.com/tsc/store_Elkcity-OK-73644_1553",
      "poi_directions_map_url": "https://maps.google.com/?cid=7062437333145033661&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "tractor-supply-co",
      "poi_latitude": "35.4124416",
      "poi_longitude": "-99.4431421",
      "poi_miles_from_property": "1.3",
      "poi_walking_minutes": "29 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 580-225-0150",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166975/019d08b5-eb62-75ad-bc25-2251dff31570.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b5-eb62-75ad-bc25-2251dff31570",
        "storage_key": "property/6767906449166975/019d08b5-eb62-75ad-bc25-2251dff31570.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ8UATEc3lq4cRvRuRClbRAmI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "store"
    },
    {
      "id": "custom_6fefea30-6722-4e4b-83bc-4c59ab80bfb4",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166975",
      "source": "custom",
      "poi_name": "Galleria Furniture , Mattress, and Appliance Outlet of Elk City",
      "poi_type": "Shopping & Retail",
      "poi_address": "3105 W 3rd St, Elk City, OK 73644, USA",
      "poi_short_description": "Furniture store carrying mattresses, appliances, and home decor, plus assembly and installation services.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166975/019d08b5-939d-770b-af98-a7333ca27169.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b5-939d-770b-af98-a7333ca27169",
        "storage_key": "property/6767906449166975/019d08b5-939d-770b-af98-a7333ca27169.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=2945697301885257436&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "galleria-furniture--mattress-and-appliance-outlet-of-elk-city",
      "poi_latitude": "35.4129898",
      "poi_longitude": "-99.4428607",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "25 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 580-303-4845",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166975/019d08b5-eb62-75ad-bc25-2251dff31570.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b5-eb62-75ad-bc25-2251dff31570",
        "storage_key": "property/6767906449166975/019d08b5-eb62-75ad-bc25-2251dff31570.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJgxfSb9Xlq4cR3IayzhY44Sg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "furniture_store"
    },
    {
      "id": "custom_01726570-aa2e-4773-b309-d049b77fe3fa",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166975",
      "source": "custom",
      "poi_name": "Sally Beauty",
      "poi_type": "Shopping & Retail",
      "poi_address": "2316 W 3rd St, Elk City, OK 73644, USA",
      "poi_short_description": "Cosmetics chain offering brand-name beauty products & supplies, including salon equipment.",
      "poi_long_description": "Cosmetics chain offering brand-name beauty products & supplies, including salon equipment.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166975/019d08b5-9605-77ba-8bba-ab4d47f461fe.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b5-9605-77ba-8bba-ab4d47f461fe",
        "storage_key": "property/6767906449166975/019d08b5-9605-77ba-8bba-ab4d47f461fe.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://stores.sallybeauty.com/ok/elkcity/beauty-supply-elkcity-ok-3378.html?utm_source=GMBlisting&utm_medium=organic",
      "poi_directions_map_url": "https://maps.google.com/?cid=18415966518927755038&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sally-beauty",
      "poi_latitude": "35.41133689999999",
      "poi_longitude": "-99.4336523",
      "poi_miles_from_property": "0.9",
      "poi_walking_minutes": "19 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 580-225-6068",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166975/019d08b5-eb62-75ad-bc25-2251dff31570.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b5-eb62-75ad-bc25-2251dff31570",
        "storage_key": "property/6767906449166975/019d08b5-eb62-75ad-bc25-2251dff31570.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ3y05ibXlq4cRHgctHPqnkv8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "store"
    },
    {
      "id": "custom_475056ce-fca9-4a59-80f4-f30fc24cf17c",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166975",
      "source": "custom",
      "poi_name": "Christi's Bazaar",
      "poi_type": "Shopping & Retail",
      "poi_address": "110 S Main St, Elk City, OK 73644, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166975/019d08b5-9606-777f-87ff-6d0658eb083b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b5-9606-777f-87ff-6d0658eb083b",
        "storage_key": "property/6767906449166975/019d08b5-9606-777f-87ff-6d0658eb083b.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=15654659164287866521&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "christis-bazaar",
      "poi_latitude": "35.4101066",
      "poi_longitude": "-99.4046859",
      "poi_miles_from_property": "2.3",
      "poi_walking_minutes": "50 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 580-225-0336",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166975/019d08b5-eb62-75ad-bc25-2251dff31570.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b5-eb62-75ad-bc25-2251dff31570",
        "storage_key": "property/6767906449166975/019d08b5-eb62-75ad-bc25-2251dff31570.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJozs7PwTlq4cRmRYxZ5GFQNk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "discount_store"
    },
    {
      "id": "custom_0c302541-5964-4e46-b2fd-33c83a6b804c",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166975",
      "source": "custom",
      "poi_name": "Elk City High School",
      "poi_type": "Education",
      "poi_address": "1221 Pioneer Rd, Elk City, OK 73644, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166975/019d08b5-9af0-74cc-87d6-74bbabd1fa55.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b5-9af0-74cc-87d6-74bbabd1fa55",
        "storage_key": "property/6767906449166975/019d08b5-9af0-74cc-87d6-74bbabd1fa55.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.elkcityschools.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15035490388081745347&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "elk-city-high-school",
      "poi_latitude": "35.4203238",
      "poi_longitude": "-99.4353527",
      "poi_miles_from_property": "0.3",
      "poi_walking_minutes": "8 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 580-225-0105",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166975/019d08b5-eb79-738e-8bd1-62af3faad494.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b5-eb79-738e-8bd1-62af3faad494",
        "storage_key": "property/6767906449166975/019d08b5-eb79-738e-8bd1-62af3faad494.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJox3KETbkq4cRw51ptdjKqNA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_78e4b929-d565-4ca6-a499-7adf5fc129a3",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166975",
      "source": "custom",
      "poi_name": "Elk City Middle School",
      "poi_type": "Education",
      "poi_address": "400 N Boone Ave, Elk City, OK 73644, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.elkcityschools.com/o/ecms",
      "poi_directions_map_url": "https://maps.google.com/?cid=6379857624794786955&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "elk-city-middle-school",
      "poi_latitude": "35.4143062",
      "poi_longitude": "-99.412242",
      "poi_miles_from_property": "1.6",
      "poi_walking_minutes": "33 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 580-225-5043",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166975/019d08b5-eb79-738e-8bd1-62af3faad494.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b5-eb79-738e-8bd1-62af3faad494",
        "storage_key": "property/6767906449166975/019d08b5-eb79-738e-8bd1-62af3faad494.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJMRj5aqrlq4cRi-x1M7XOiVg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_23728328-8f0c-406a-a51d-e409189d87e7",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166975",
      "source": "custom",
      "poi_name": "Elk City Intermediate School",
      "poi_type": "Education",
      "poi_address": "800 N Pioneer Rd, Elk City, OK 73644, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.elkcityschools.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14509508519463041516&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "elk-city-intermediate-school",
      "poi_latitude": "35.4175391",
      "poi_longitude": "-99.4340963",
      "poi_miles_from_property": "0.4",
      "poi_walking_minutes": "9 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 580-225-2687",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166975/019d08b5-eb79-738e-8bd1-62af3faad494.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b5-eb79-738e-8bd1-62af3faad494",
        "storage_key": "property/6767906449166975/019d08b5-eb79-738e-8bd1-62af3faad494.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJydNsgUrkq4cR7DkZsB8hXMk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_2f5f8e81-66f9-4446-8434-dc535aaf3e9c",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166975",
      "source": "custom",
      "poi_name": "Fairview Elementary School",
      "poi_type": "Education",
      "poi_address": "1502 W 7th St, Elk City, OK 73644, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=9521912981399062367&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "fairview-elementary-school",
      "poi_latitude": "35.40812349999999",
      "poi_longitude": "-99.4222701",
      "poi_miles_from_property": "1.5",
      "poi_walking_minutes": "33 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 580-225-2590",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166975/019d08b5-eb79-738e-8bd1-62af3faad494.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b5-eb79-738e-8bd1-62af3faad494",
        "storage_key": "property/6767906449166975/019d08b5-eb79-738e-8bd1-62af3faad494.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ_yxDzq_lq4cRX8d4RmihJIQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_01e01cb7-4a1c-455b-a4fa-ba1833852fc9",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166975",
      "source": "custom",
      "poi_name": "Western Technology Center - Elk City Campus",
      "poi_type": "Education",
      "poi_address": "301 Western Dr, Elk City, OK 73644, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166975/019d08b5-9adf-76aa-8440-fb2aeba18943.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b5-9adf-76aa-8440-fb2aeba18943",
        "storage_key": "property/6767906449166975/019d08b5-9adf-76aa-8440-fb2aeba18943.webp",
        "width": 450,
        "height": 300
      },
      "poi_business_url": "http://www.westtech.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14465938203486703225&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "western-technology-center---elk-city-campus",
      "poi_latitude": "35.4132766",
      "poi_longitude": "-99.4414978",
      "poi_miles_from_property": "1",
      "poi_walking_minutes": "22 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 580-225-4982",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166975/019d08b5-eb79-738e-8bd1-62af3faad494.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b5-eb79-738e-8bd1-62af3faad494",
        "storage_key": "property/6767906449166975/019d08b5-eb79-738e-8bd1-62af3faad494.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJLxKwwczlq4cRec6T-SZWwcg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_1615da56-8c61-4f33-8c4f-5b06ba281ba5",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166975",
      "source": "custom",
      "poi_name": "Western Oklahoma Christian School",
      "poi_type": "Education",
      "poi_address": "2001 S Randall Ave, Elk City, OK 73644, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166975/019d08b5-9cfd-75cf-99e3-7c946fd8995c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b5-9cfd-75cf-99e3-7c946fd8995c",
        "storage_key": "property/6767906449166975/019d08b5-9cfd-75cf-99e3-7c946fd8995c.webp",
        "width": 1147,
        "height": 451
      },
      "poi_business_url": "https://www.wocs.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10146429566982678781&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "western-oklahoma-christian-school",
      "poi_latitude": "35.3924156",
      "poi_longitude": "-99.4179784",
      "poi_miles_from_property": "2.9",
      "poi_walking_minutes": "1 hour 3 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 580-303-4922",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166975/019d08b5-eb79-738e-8bd1-62af3faad494.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b5-eb79-738e-8bd1-62af3faad494",
        "storage_key": "property/6767906449166975/019d08b5-eb79-738e-8bd1-62af3faad494.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ17xrsA3lq4cR_eiF3u5bz4w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_d0bb27c9-253a-4187-9b01-24217027489a",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166975",
      "source": "custom",
      "poi_name": "Elk City Head Start",
      "poi_type": "Education",
      "poi_address": "215 W 12th St, Elk City, OK 73644, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=5453648888420516622&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "elk-city-head-start",
      "poi_latitude": "35.402239",
      "poi_longitude": "-99.4070488",
      "poi_miles_from_property": "2.7",
      "poi_walking_minutes": "1 hour 0 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 580-225-4103",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166975/019d08b5-e667-73ac-9fec-ff53f91b1d73.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b5-e667-73ac-9fec-ff53f91b1d73",
        "storage_key": "property/6767906449166975/019d08b5-e667-73ac-9fec-ff53f91b1d73.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJifRIQLDlq4cRDkMC9MRAr0s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_61df8a75-8d06-49d5-8e0b-cde68c1d7000",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166975",
      "source": "custom",
      "poi_name": "Wonder World Preschool",
      "poi_type": "Education",
      "poi_address": "720 W Country Club Blvd, Elk City, OK 73644, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=5749211541875809397&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "wonder-world-preschool",
      "poi_latitude": "35.4217328",
      "poi_longitude": "-99.4127644",
      "poi_miles_from_property": "1.2",
      "poi_walking_minutes": "26 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 580-225-0262",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166975/019d08b5-eb79-738e-8bd1-62af3faad494.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b5-eb79-738e-8bd1-62af3faad494",
        "storage_key": "property/6767906449166975/019d08b5-eb79-738e-8bd1-62af3faad494.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJs5U_Sf_kq4cRdVwVzG9NyU8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "preschool"
    },
    {
      "id": "custom_0f8de3c1-90a8-4aa3-9128-8f2080483796",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166975",
      "source": "custom",
      "poi_name": "Loving Hearts & Hands Cdc Llc",
      "poi_type": "Education",
      "poi_address": "712 N Washington Ave, Elk City, OK 73644, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=16869361504907898720&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "loving-hearts--hands-cdc-llc",
      "poi_latitude": "35.4169193",
      "poi_longitude": "-99.4083321",
      "poi_miles_from_property": "1.6",
      "poi_walking_minutes": "35 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 580-339-8131",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166975/019d08b5-eb79-738e-8bd1-62af3faad494.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b5-eb79-738e-8bd1-62af3faad494",
        "storage_key": "property/6767906449166975/019d08b5-eb79-738e-8bd1-62af3faad494.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJrx6n1wHlq4cRYC-vN-kCHOo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "child_care_agency"
    },
    {
      "id": "custom_68434cd3-837a-4a23-9f28-a3795d0303fb",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166975",
      "source": "custom",
      "poi_name": "Old Town Museum",
      "poi_type": "Entertainment",
      "poi_address": "2717 W 3rd St, Elk City, OK 73644, USA",
      "poi_short_description": "Museum in a bi-level Victorian home exhibiting artifacts from the pioneer, cowboy & rodeo days.",
      "poi_long_description": "Museum in a bi-level Victorian home exhibiting artifacts from the pioneer, cowboy & rodeo days.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166975/019d08b5-9d76-70b6-bd38-acba687fdef8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b5-9d76-70b6-bd38-acba687fdef8",
        "storage_key": "property/6767906449166975/019d08b5-9d76-70b6-bd38-acba687fdef8.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.elkcity.com/city-hall/departments/elk-city-museums/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16194573502904490157&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "old-town-museum",
      "poi_latitude": "35.4120204",
      "poi_longitude": "-99.4368126",
      "poi_miles_from_property": "0.9",
      "poi_walking_minutes": "20 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 580-225-2207",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166975/019d08b5-f02b-75a1-a4d7-727d83500a13.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b5-f02b-75a1-a4d7-727d83500a13",
        "storage_key": "property/6767906449166975/019d08b5-f02b-75a1-a4d7-727d83500a13.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJQ_aJVsrlq4cRrViTYcyuvuA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_3e5b93ba-08da-4388-8483-17a4b001e444",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166975",
      "source": "custom",
      "poi_name": "Flix On 6",
      "poi_type": "Entertainment",
      "poi_address": "2103 S Main St, Elk City, OK 73644, USA",
      "poi_short_description": "First-run movies are presented at this family-operated multiplex theater with stadium seating.",
      "poi_long_description": "First-run movies are presented at this family-operated multiplex theater with stadium seating.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166975/019d08b5-a0f2-74d1-8af0-587b7f885433.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b5-a0f2-74d1-8af0-587b7f885433",
        "storage_key": "property/6767906449166975/019d08b5-a0f2-74d1-8af0-587b7f885433.webp",
        "width": 1080,
        "height": 614
      },
      "poi_business_url": "http://www.flixon6.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8942550612411500321&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "flix-on-6",
      "poi_latitude": "35.39087860000001",
      "poi_longitude": "-99.4063551",
      "poi_miles_from_property": "3.6",
      "poi_walking_minutes": "1 hour 18 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 580-243-3545",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166975/019d08b5-f078-72ad-91f1-9656cc3541b0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b5-f078-72ad-91f1-9656cc3541b0",
        "storage_key": "property/6767906449166975/019d08b5-f078-72ad-91f1-9656cc3541b0.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJQQEilnPlq4cRIUe9_mZSGnw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "custom_965c5c99-c3d2-46eb-bba2-37c8489ba222",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166975",
      "source": "custom",
      "poi_name": "The Pitstop",
      "poi_type": "Entertainment",
      "poi_address": "2500 S Main St, Elk City, OK 73644, USA",
      "poi_short_description": "Lively hangout decked out with a pool table.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166975/019d08b5-a34c-70f9-922d-6504ca04887d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b5-a34c-70f9-922d-6504ca04887d",
        "storage_key": "property/6767906449166975/019d08b5-a34c-70f9-922d-6504ca04887d.webp",
        "width": 591,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=2491553211345663315&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-pitstop",
      "poi_latitude": "35.3920402",
      "poi_longitude": "-99.40316",
      "poi_miles_from_property": "3.7",
      "poi_walking_minutes": "1 hour 19 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 580-225-6320",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166975/019d08b5-e5d6-741d-8ef8-efc8c995f3ee.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b5-e5d6-741d-8ef8-efc8c995f3ee",
        "storage_key": "property/6767906449166975/019d08b5-e5d6-741d-8ef8-efc8c995f3ee.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJaShvEVrlq4cRU_U95XHGkyI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bar"
    },
    {
      "id": "custom_3976a238-ce90-4c71-934d-d8872d334a80",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166975",
      "source": "custom",
      "poi_name": "Blockhouse Sports Bar",
      "poi_type": "Entertainment",
      "poi_address": "20096 E 1090 Rd, Elk City, OK 73644, USA",
      "poi_short_description": "Casual establishment featuring a jukebox, billiards and a patio, as well as flat-screen TVs showing sports.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166975/019d08b5-a512-7179-b8f3-2c69d0dd4861.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b5-a512-7179-b8f3-2c69d0dd4861",
        "storage_key": "property/6767906449166975/019d08b5-a512-7179-b8f3-2c69d0dd4861.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=4402833883886254529&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "blockhouse-sports-bar",
      "poi_latitude": "35.4360351",
      "poi_longitude": "-99.4000091",
      "poi_miles_from_property": "2.9",
      "poi_walking_minutes": "1 hour 4 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166975/019d08b5-e5d6-741d-8ef8-efc8c995f3ee.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b5-e5d6-741d-8ef8-efc8c995f3ee",
        "storage_key": "property/6767906449166975/019d08b5-e5d6-741d-8ef8-efc8c995f3ee.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJBSDxvIblq4cRwfkXFhcCGj0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bar"
    },
    {
      "id": "custom_6d0e8525-e0b9-43d2-8329-7ba9a020821d",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166975",
      "source": "custom",
      "poi_name": "Knucklehead Red's Saloon",
      "poi_type": "Entertainment",
      "poi_address": "2417 W Broadway Ave, Elk City, OK 73644, USA",
      "poi_short_description": "Casual eatery featuring pool tables, live music and a dancefloor, along with a bar.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166975/019d08b5-a6e4-75bc-8c9d-453a02cd5177.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b5-a6e4-75bc-8c9d-453a02cd5177",
        "storage_key": "property/6767906449166975/019d08b5-a6e4-75bc-8c9d-453a02cd5177.webp",
        "width": 1280,
        "height": 598
      },
      "poi_business_url": "https://www.facebook.com/steven.beck.5602/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13101340945188146472&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "knucklehead-reds-saloon",
      "poi_latitude": "35.4110584",
      "poi_longitude": "-99.4337464",
      "poi_miles_from_property": "1",
      "poi_walking_minutes": "21 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166975/019d08b5-e5d6-741d-8ef8-efc8c995f3ee.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b5-e5d6-741d-8ef8-efc8c995f3ee",
        "storage_key": "property/6767906449166975/019d08b5-e5d6-741d-8ef8-efc8c995f3ee.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJVV458rXlq4cRKE04_yxQ0bU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bar"
    },
    {
      "id": "custom_792ff086-4a64-41d0-b337-de65c123ffbf",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166975",
      "source": "custom",
      "poi_name": "PLAY On Main",
      "poi_type": "Entertainment",
      "poi_address": "916 S Main St, Elk City, OK 73644, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166975/019d08b5-b029-74f1-a3cf-e2d3c1753c05.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b5-b029-74f1-a3cf-e2d3c1753c05",
        "storage_key": "property/6767906449166975/019d08b5-b029-74f1-a3cf-e2d3c1753c05.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.playonmain.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10419292790377941845&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "play-on-main",
      "poi_latitude": "35.4010489",
      "poi_longitude": "-99.4045836",
      "poi_miles_from_property": "2.9",
      "poi_walking_minutes": "1 hour 4 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 580-303-4991",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166975/019d08b5-e667-73ac-9fec-ff53f91b1d73.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b5-e667-73ac-9fec-ff53f91b1d73",
        "storage_key": "property/6767906449166975/019d08b5-e667-73ac-9fec-ff53f91b1d73.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJi6DbbULlq4cRVQtEzZbDmJA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "playground"
    },
    {
      "id": "custom_b8a2f759-5d89-49f6-a281-51e56ab0c73c",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166975",
      "source": "custom",
      "poi_name": "Boomtown Grill",
      "poi_type": "Entertainment",
      "poi_address": "2103 S Main St Ste. C, Elk City, OK 73644, USA",
      "poi_short_description": "Wings, burgers, fried chicken and beer are served at this informal, family-friendly spot.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166975/019d08b5-82bd-7640-904a-b3a4b3b914cf.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b5-82bd-7640-904a-b3a4b3b914cf",
        "storage_key": "property/6767906449166975/019d08b5-82bd-7640-904a-b3a4b3b914cf.webp",
        "width": 1280,
        "height": 721
      },
      "poi_business_url": "https://www.boomtowngrill.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12876707735943372764&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "boomtown-grill",
      "poi_latitude": "35.3907208",
      "poi_longitude": "-99.4054844",
      "poi_miles_from_property": "3.6",
      "poi_walking_minutes": "1 hour 18 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 580-225-3463",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166975/019d08b5-e666-73ef-865e-b085f9a8f5dc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b5-e666-73ef-865e-b085f9a8f5dc",
        "storage_key": "property/6767906449166975/019d08b5-e666-73ef-865e-b085f9a8f5dc.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJc4JSuXPlq4cR3N9tTXZBs7I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_d442abd2-ea7b-4ffb-af70-2c0d265d8b31",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166975",
      "source": "custom",
      "poi_name": "Community Civic Center",
      "poi_type": "Entertainment",
      "poi_address": "1016 Airport Industrial, Elk City, OK 73644, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166975/019d08b5-b05d-70e9-a92d-333b219a74bc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b5-b05d-70e9-a92d-333b219a74bc",
        "storage_key": "property/6767906449166975/019d08b5-b05d-70e9-a92d-333b219a74bc.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=13981491998362647271&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "community-civic-center",
      "poi_latitude": "35.4210041",
      "poi_longitude": "-99.3900343",
      "poi_miles_from_property": "2.6",
      "poi_walking_minutes": "57 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 580-225-0906",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166975/019d08b5-e667-73ac-9fec-ff53f91b1d73.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b5-e667-73ac-9fec-ff53f91b1d73",
        "storage_key": "property/6767906449166975/019d08b5-e667-73ac-9fec-ff53f91b1d73.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJAUnhneDkq4cR5zpfOOU8CMI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "auditorium"
    },
    {
      "id": "custom_f44c2f2f-ecd2-48ea-96ee-f8d90b8b37e2",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166975",
      "source": "custom",
      "poi_name": "Great Plains Regional Medical Center",
      "poi_type": "Health and Wellness",
      "poi_address": "1801 W 3rd St, Elk City, OK 73644, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166975/019d08b5-b39f-75ac-9b75-94839338fef3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b5-b39f-75ac-9b75-94839338fef3",
        "storage_key": "property/6767906449166975/019d08b5-b39f-75ac-9b75-94839338fef3.webp",
        "width": 1024,
        "height": 683
      },
      "poi_business_url": "http://www.gprmc-ok.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1209569454627140351&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "great-plains-regional-medical-center",
      "poi_latitude": "35.4138726",
      "poi_longitude": "-99.4262494",
      "poi_miles_from_property": "1",
      "poi_walking_minutes": "21 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 580-225-2511",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166975/019d08b5-f5f5-763b-bc62-6a3528b5fc1c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b5-f5f5-763b-bc62-6a3528b5fc1c",
        "storage_key": "property/6767906449166975/019d08b5-f5f5-763b-bc62-6a3528b5fc1c.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJTck2AbPlq4cR_7I2qgJByRA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_a4f9b7e6-515a-4132-a133-d98237967ecb",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166975",
      "source": "custom",
      "poi_name": "GPRMC Urgent Care Clinic",
      "poi_type": "Health and Wellness",
      "poi_address": "404 S Eastern Ave, Elk City, OK 73644, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166975/019d08b5-b641-76b1-887a-1690d70ea937.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b5-b641-76b1-887a-1690d70ea937",
        "storage_key": "property/6767906449166975/019d08b5-b641-76b1-887a-1690d70ea937.webp",
        "width": 1280,
        "height": 862
      },
      "poi_business_url": "https://gprmc-ok.com/urgent-care/",
      "poi_directions_map_url": "https://maps.google.com/?cid=157092626409201973&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "gprmc-urgent-care-clinic",
      "poi_latitude": "35.4066863",
      "poi_longitude": "-99.3806193",
      "poi_miles_from_property": "4",
      "poi_walking_minutes": "1 hour 27 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 580-303-5890",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166975/019d08b5-e667-73ac-9fec-ff53f91b1d73.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b5-e667-73ac-9fec-ff53f91b1d73",
        "storage_key": "property/6767906449166975/019d08b5-e667-73ac-9fec-ff53f91b1d73.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJvxhWNiflq4cRNSH0UekaLgI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "health"
    },
    {
      "id": "custom_c6a93dbd-af37-4692-ba6f-c2a78fff49fd",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166975",
      "source": "custom",
      "poi_name": "Xpress Wellness Urgent Care - Elk City",
      "poi_type": "Health and Wellness",
      "poi_address": "411 W 3rd St, Elk City, OK 73644, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166975/019d08b5-b8fb-720f-b356-d677494987a1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b5-b8fb-720f-b356-d677494987a1",
        "storage_key": "property/6767906449166975/019d08b5-b8fb-720f-b356-d677494987a1.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://xpresswellnessurgentcare.com/locations/oklahoma/elk-city/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10768485197577272008&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "xpress-wellness-urgent-care---elk-city",
      "poi_latitude": "35.4120132",
      "poi_longitude": "-99.4095586",
      "poi_miles_from_property": "1.9",
      "poi_walking_minutes": "42 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 580-303-9293",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166975/019d08b5-e667-73ac-9fec-ff53f91b1d73.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b5-e667-73ac-9fec-ff53f91b1d73",
        "storage_key": "property/6767906449166975/019d08b5-e667-73ac-9fec-ff53f91b1d73.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ6YcQKwHlq4cRyDqlujtYcZU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "health"
    },
    {
      "id": "custom_276f5636-c1ae-412b-adc2-2dcab8a281a8",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166975",
      "source": "custom",
      "poi_name": "Walgreens",
      "poi_type": "Health and Wellness",
      "poi_address": "115 W 3rd St, Elk City, OK 73644, USA",
      "poi_short_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_long_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166975/019d08b5-8b0e-7443-886a-38aeb12d59d0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b5-8b0e-7443-886a-38aeb12d59d0",
        "storage_key": "property/6767906449166975/019d08b5-8b0e-7443-886a-38aeb12d59d0.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-115+w+3rd+st-elk+city-ok-73644/id=9874",
      "poi_directions_map_url": "https://maps.google.com/?cid=17531138606873173&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens",
      "poi_latitude": "35.4122316",
      "poi_longitude": "-99.4057989",
      "poi_miles_from_property": "2.1",
      "poi_walking_minutes": "45 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 580-225-4418",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166975/019d08b5-e667-73ac-9fec-ff53f91b1d73.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b5-e667-73ac-9fec-ff53f91b1d73",
        "storage_key": "property/6767906449166975/019d08b5-e667-73ac-9fec-ff53f91b1d73.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_cX2CQTlq4cRVborSXpIPgA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "drugstore"
    },
    {
      "id": "custom_e11666a0-d607-48c2-902e-a914d7072687",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166975",
      "source": "custom",
      "poi_name": "Homeland Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "412 W 3rd St, Elk City, OK 73644, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://hacweb.rxtouch.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4395810488351849367&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "homeland-pharmacy",
      "poi_latitude": "35.4110735",
      "poi_longitude": "-99.4091168",
      "poi_miles_from_property": "2",
      "poi_walking_minutes": "43 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 580-225-7961",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166975/019d08b5-eb62-75ad-bc25-2251dff31570.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b5-eb62-75ad-bc25-2251dff31570",
        "storage_key": "property/6767906449166975/019d08b5-eb62-75ad-bc25-2251dff31570.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJrbEYKwHlq4cRl_slYlkOAT0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "store"
    },
    {
      "id": "custom_780de9f7-b6e2-4e08-b5c5-fe4d276f4eff",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166975",
      "source": "custom",
      "poi_name": "Paul Jones Drug",
      "poi_type": "Health and Wellness",
      "poi_address": "809 N Main St, Elk City, OK 73644, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166975/019d08b5-bc33-74ef-8dbc-094db083f0ec.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b5-bc33-74ef-8dbc-094db083f0ec",
        "storage_key": "property/6767906449166975/019d08b5-bc33-74ef-8dbc-094db083f0ec.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://pauljonesdrug.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13335305541602734711&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "paul-jones-drug",
      "poi_latitude": "35.4180854",
      "poi_longitude": "-99.4052474",
      "poi_miles_from_property": "2",
      "poi_walking_minutes": "42 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 580-225-2121",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166975/019d08b5-f5f3-7385-a603-06889ebf0bba.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b5-f5f3-7385-a603-06889ebf0bba",
        "storage_key": "property/6767906449166975/019d08b5-f5f3-7385-a603-06889ebf0bba.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ8TL4FATlq4cRd3KHkryFELk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_4c49fd25-eb26-4c02-b873-ef5fd0d21269",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166975",
      "source": "custom",
      "poi_name": "The Rig Gym",
      "poi_type": "Health and Wellness",
      "poi_address": "408 S Jefferson St, Elk City, OK 73644, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166975/019d08b5-bd89-75e9-9158-049ec6b3b53b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b5-bd89-75e9-9158-049ec6b3b53b",
        "storage_key": "property/6767906449166975/019d08b5-bd89-75e9-9158-049ec6b3b53b.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=6728145035199562682&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-rig-gym",
      "poi_latitude": "35.4070271",
      "poi_longitude": "-99.4060368",
      "poi_miles_from_property": "2.4",
      "poi_walking_minutes": "53 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 580-339-1787",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166975/019d08b5-e667-73ac-9fec-ff53f91b1d73.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b5-e667-73ac-9fec-ff53f91b1d73",
        "storage_key": "property/6767906449166975/019d08b5-e667-73ac-9fec-ff53f91b1d73.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJsYOLW_3lq4cRusNgJEMsX10",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_3b4b8747-f297-4140-9626-e64edecfe7da",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166975",
      "source": "custom",
      "poi_name": "Velox Strength and Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "504 W 20th St, Elk City, OK 73644, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166975/019d08b5-bf5a-7252-85e9-98f345e4034e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b5-bf5a-7252-85e9-98f345e4034e",
        "storage_key": "property/6767906449166975/019d08b5-bf5a-7252-85e9-98f345e4034e.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=18148594753891269525&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "velox-strength-and-fitness",
      "poi_latitude": "35.3925047",
      "poi_longitude": "-99.4115028",
      "poi_miles_from_property": "3.1",
      "poi_walking_minutes": "1 hour 8 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 580-303-1321",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166975/019d08b5-e667-73ac-9fec-ff53f91b1d73.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b5-e667-73ac-9fec-ff53f91b1d73",
        "storage_key": "property/6767906449166975/019d08b5-e667-73ac-9fec-ff53f91b1d73.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJbVUxD3Xlq4cRlfs09sXC3Ps",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_ae77912d-1e3f-4513-8a13-3297777d1e3b",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166975",
      "source": "custom",
      "poi_name": "Superior Health & Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "1007 N Main St, Elk City, OK 73644, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=46416461875023928&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "superior-health--fitness",
      "poi_latitude": "35.4196883",
      "poi_longitude": "-99.4064272",
      "poi_miles_from_property": "2",
      "poi_walking_minutes": "42 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 580-243-6767",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166975/019d08b5-e667-73ac-9fec-ff53f91b1d73.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b5-e667-73ac-9fec-ff53f91b1d73",
        "storage_key": "property/6767906449166975/019d08b5-e667-73ac-9fec-ff53f91b1d73.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-dMMyP3kq4cROJDKsYbnpAA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fitness_center"
    },
    {
      "id": "custom_ffe6ba63-4d89-400b-ae6f-3dd843f1c4e3",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166975",
      "source": "custom",
      "poi_name": "Physical Therapy Central",
      "poi_type": "Health and Wellness",
      "poi_address": "1007 N Main St Suite 102, Elk City, OK 73644, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166975/019d08b5-c070-71ca-84d2-08e4928dd056.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b5-c070-71ca-84d2-08e4928dd056",
        "storage_key": "property/6767906449166975/019d08b5-c070-71ca-84d2-08e4928dd056.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://ptcentral.org/location/elk-city/?UTM_source=GMB_listing&UTM_medium=organic%EF%BB%BF%EF%BB%BF%EF%BB%BF",
      "poi_directions_map_url": "https://maps.google.com/?cid=17885019709389200330&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "physical-therapy-central",
      "poi_latitude": "35.4196883",
      "poi_longitude": "-99.4064272",
      "poi_miles_from_property": "2",
      "poi_walking_minutes": "42 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 580-225-0075",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166975/019d08b5-e667-73ac-9fec-ff53f91b1d73.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b5-e667-73ac-9fec-ff53f91b1d73",
        "storage_key": "property/6767906449166975/019d08b5-e667-73ac-9fec-ff53f91b1d73.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJpcpQ83Plq4cRytsAs6paNPg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "health"
    },
    {
      "id": "custom_fee44112-c257-490d-8cd3-8a00537d2cee",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166975",
      "source": "custom",
      "poi_name": "Colonel Herring Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Colonel Herring Park, 321 W Country Club Blvd, Elk City, OK 73644, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=18347049000009476931&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "colonel-herring-park",
      "poi_latitude": "35.422215",
      "poi_longitude": "-99.40632560000002",
      "poi_miles_from_property": "1.6",
      "poi_walking_minutes": "34 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166975/019d08b5-f157-74b4-b1a3-c2f6e2cb9236.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b5-f157-74b4-b1a3-c2f6e2cb9236",
        "storage_key": "property/6767906449166975/019d08b5-f157-74b4-b1a3-c2f6e2cb9236.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJKd73FQDlq4cRQytA0tvPnf4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_533dbad5-fe10-453b-aa3b-c6205f10df79",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166975",
      "source": "custom",
      "poi_name": "Ackley Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Elk City, OK 73644, USA",
      "poi_short_description": "220-acre park with a carousel, softball complex & picnic shelters, plus a seasonal pool & mini-golf.",
      "poi_long_description": "220-acre park with a carousel, softball complex & picnic shelters, plus a seasonal pool & mini-golf.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166975/019d08b5-a966-700f-9e07-7fc5bc792baa.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b5-a966-700f-9e07-7fc5bc792baa",
        "storage_key": "property/6767906449166975/019d08b5-a966-700f-9e07-7fc5bc792baa.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.elkcity.com/city-hall/departments/parks-department/ackley-park/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13973795923092422598&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ackley-park",
      "poi_latitude": "35.4129754",
      "poi_longitude": "-99.4333817",
      "poi_miles_from_property": "0.8",
      "poi_walking_minutes": "18 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 580-225-3230",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166975/019d08b5-f157-74b4-b1a3-c2f6e2cb9236.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b5-f157-74b4-b1a3-c2f6e2cb9236",
        "storage_key": "property/6767906449166975/019d08b5-f157-74b4-b1a3-c2f6e2cb9236.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJA2O3ocrlq4cRxr-5D1vl7ME",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_5e9e3d5c-e7bc-4319-9d91-d1a5b1b6ffd8",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166975",
      "source": "custom",
      "poi_name": "Jaycee Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "100 Calhoon St, Elk City, OK 73644, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166975/019d08b5-c6d8-7378-9b75-a1a8e5628ec2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b5-c6d8-7378-9b75-a1a8e5628ec2",
        "storage_key": "property/6767906449166975/019d08b5-c6d8-7378-9b75-a1a8e5628ec2.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=11644542863703076622&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "jaycee-park",
      "poi_latitude": "35.4161673",
      "poi_longitude": "-99.3822243",
      "poi_miles_from_property": "3.4",
      "poi_walking_minutes": "1 hour 15 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166975/019d08b5-f157-74b4-b1a3-c2f6e2cb9236.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b5-f157-74b4-b1a3-c2f6e2cb9236",
        "storage_key": "property/6767906449166975/019d08b5-f157-74b4-b1a3-c2f6e2cb9236.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJxz5SYlPlq4cRDu_UAgq6maE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_2b27776c-549e-4b62-a263-279358502d4a",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166975",
      "source": "custom",
      "poi_name": "Kiwanis Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1300 W 9th St, Elk City, OK 73644, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166975/019d08b5-c6d9-7092-8bed-f5dff3c49978.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b5-c6d9-7092-8bed-f5dff3c49978",
        "storage_key": "property/6767906449166975/019d08b5-c6d9-7092-8bed-f5dff3c49978.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=2639815363630010691&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kiwanis-park",
      "poi_latitude": "35.4058899",
      "poi_longitude": "-99.4202364",
      "poi_miles_from_property": "1.8",
      "poi_walking_minutes": "39 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166975/019d08b5-f157-74b4-b1a3-c2f6e2cb9236.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b5-f157-74b4-b1a3-c2f6e2cb9236",
        "storage_key": "property/6767906449166975/019d08b5-f157-74b4-b1a3-c2f6e2cb9236.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJQ2K1Yejlq4cRQxHJPRaCoiQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_923772e3-6bb6-44ac-a2d8-051b4fd17de0",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166975",
      "source": "custom",
      "poi_name": "Lincoln Teen Center",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1400 S Franklin St, Elk City, OK 73644, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166975/019d08b5-cb4b-718f-888e-97c02fafbadd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b5-cb4b-718f-888e-97c02fafbadd",
        "storage_key": "property/6767906449166975/019d08b5-cb4b-718f-888e-97c02fafbadd.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=8029301907884860347&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lincoln-teen-center",
      "poi_latitude": "35.3982011",
      "poi_longitude": "-99.4104256",
      "poi_miles_from_property": "3",
      "poi_walking_minutes": "1 hour 6 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 580-303-9025",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166975/019d08b5-e667-73ac-9fec-ff53f91b1d73.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b5-e667-73ac-9fec-ff53f91b1d73",
        "storage_key": "property/6767906449166975/019d08b5-e667-73ac-9fec-ff53f91b1d73.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJl30tZArlq4cRu-PXTYvPbW8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sports_activity_location"
    },
    {
      "id": "custom_6dbc5334-3a95-435d-a7fa-12f48ce28faa",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166975",
      "source": "custom",
      "poi_name": "Ackley Park West",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Elk City, OK 73644, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166975/019d08b5-c9f5-7428-8b45-c60b04c8ad78.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b5-c9f5-7428-8b45-c60b04c8ad78",
        "storage_key": "property/6767906449166975/019d08b5-c9f5-7428-8b45-c60b04c8ad78.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=10164754160504351334&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ackley-park-west",
      "poi_latitude": "35.4162111",
      "poi_longitude": "-99.4367361",
      "poi_miles_from_property": "0.7",
      "poi_walking_minutes": "14 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166975/019d08b5-f157-74b4-b1a3-c2f6e2cb9236.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b5-f157-74b4-b1a3-c2f6e2cb9236",
        "storage_key": "property/6767906449166975/019d08b5-f157-74b4-b1a3-c2f6e2cb9236.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJU7z08jvlq4cRZioJxg12EI0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_62952190-d966-4446-a0cb-c9c28622c8e9",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166975",
      "source": "custom",
      "poi_name": "Elk City Lake Park campground",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "D1137 Rd, Elk City, OK 73644, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166975/019d08b5-ac5c-77a8-9594-4a44ab258519.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b5-ac5c-77a8-9594-4a44ab258519",
        "storage_key": "property/6767906449166975/019d08b5-ac5c-77a8-9594-4a44ab258519.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.elkcity.com/city-hall/departments/parks-department/elk-city-lake/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13310627304649885072&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "elk-city-lake-park-campground",
      "poi_latitude": "35.366042",
      "poi_longitude": "-99.4154983",
      "poi_miles_from_property": "5.5",
      "poi_walking_minutes": "1 hour 59 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 580-225-3990",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166975/019d08b5-f1bf-73c9-90eb-5391e7b8c720.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b5-f1bf-73c9-90eb-5391e7b8c720",
        "storage_key": "property/6767906449166975/019d08b5-f1bf-73c9-90eb-5391e7b8c720.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ922FFnnvq4cRkIVFxwLZuLg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "campground"
    },
    {
      "id": "custom_c475bc5b-1622-4f4e-a567-2ecc3e3e63c0",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166975",
      "source": "custom",
      "poi_name": "Elk City Golf & Country Club",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Lakeridge Rd, Elk City, OK 73644, USA",
      "poi_short_description": "Country club offering a challenging golf course and driving range, as well as a pro shop.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166975/019d08b5-cf38-7313-9ac1-d79cf9c8f46d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b5-cf38-7313-9ac1-d79cf9c8f46d",
        "storage_key": "property/6767906449166975/019d08b5-cf38-7313-9ac1-d79cf9c8f46d.webp",
        "width": 1280,
        "height": 1022
      },
      "poi_business_url": "http://www.elkcitygolf.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6534529458274795870&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "elk-city-golf--country-club",
      "poi_latitude": "35.3637237",
      "poi_longitude": "-99.4027328",
      "poi_miles_from_property": "5.6",
      "poi_walking_minutes": "2 hours 0 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 580-225-3556",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166975/019d08b5-e667-73ac-9fec-ff53f91b1d73.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b5-e667-73ac-9fec-ff53f91b1d73",
        "storage_key": "property/6767906449166975/019d08b5-e667-73ac-9fec-ff53f91b1d73.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_-rj-I_vq4cRXoHLvutPr1o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_c0153ca4-583f-486c-9ade-f5f514dc3899",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166975",
      "source": "custom",
      "poi_name": "Elk City Municipal Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "101 Norman Martin Blvd, Elk City, OK 73644, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166975/019d08b5-d053-7572-a791-362f10907eaa.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b5-d053-7572-a791-362f10907eaa",
        "storage_key": "property/6767906449166975/019d08b5-d053-7572-a791-362f10907eaa.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.elkcity.com/city-hall/departments/airport/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6815549716414817956&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "elk-city-municipal-airport",
      "poi_latitude": "35.425976",
      "poi_longitude": "-99.3958509",
      "poi_miles_from_property": "2.4",
      "poi_walking_minutes": "53 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 580-225-7700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166975/019d08b5-f6bd-70de-9d2e-b3ccbd2bdbfa.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b5-f6bd-70de-9d2e-b3ccbd2bdbfa",
        "storage_key": "property/6767906449166975/019d08b5-f6bd-70de-9d2e-b3ccbd2bdbfa.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJLyhJguDlq4cRpGbrU1uylV4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "airport"
    },
    {
      "id": "custom_e2540ad4-bf1b-4f30-b25c-6a4d30db10a5",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166975",
      "source": "custom",
      "poi_name": "Greyhound: Bus Station",
      "poi_type": "Transportation & Transit",
      "poi_address": "Jct 6 & Hwy 66, 5100 W 3rd St, Elk City, OK 73644, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166975/019d08b5-d3c3-77ba-a9b7-fa2155456244.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b5-d3c3-77ba-a9b7-fa2155456244",
        "storage_key": "property/6767906449166975/019d08b5-d3c3-77ba-a9b7-fa2155456244.webp",
        "width": 1000,
        "height": 1000
      },
      "poi_business_url": "https://www.greyhound.com/en-us/bus-station-670186",
      "poi_directions_map_url": "https://maps.google.com/?cid=3449356901382581836&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "greyhound-bus-station",
      "poi_latitude": "35.4088418",
      "poi_longitude": "-99.4711706",
      "poi_miles_from_property": "2.8",
      "poi_walking_minutes": "1 hour 3 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 580-225-8649",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166975/019d08b5-e667-73ac-9fec-ff53f91b1d73.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b5-e667-73ac-9fec-ff53f91b1d73",
        "storage_key": "property/6767906449166975/019d08b5-e667-73ac-9fec-ff53f91b1d73.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJK_d0sWPmq4cRTG5zitOT3i8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_f27187a6-6547-4977-911e-7425fb23eac7",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166975",
      "source": "custom",
      "poi_name": "Love's Travel Stop",
      "poi_type": "Transportation & Transit",
      "poi_address": "2703 U.S. Rte 66, Elk City, OK 73644, USA",
      "poi_short_description": "Chain truck stop offering fuel, snacks, and other travel necessities, plus clean restrooms.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166975/019d08b5-d4b0-775b-9207-90c4e2dff2c6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b5-d4b0-775b-9207-90c4e2dff2c6",
        "storage_key": "property/6767906449166975/019d08b5-d4b0-775b-9207-90c4e2dff2c6.webp",
        "width": 609,
        "height": 368
      },
      "poi_business_url": "https://www.loves.com/locations/201",
      "poi_directions_map_url": "https://maps.google.com/?cid=2426491255109843683&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "loves-travel-stop",
      "poi_latitude": "35.4229483",
      "poi_longitude": "-99.3723378",
      "poi_miles_from_property": "3.6",
      "poi_walking_minutes": "1 hour 20 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 580-225-9162",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166975/019d08b5-eb62-75ad-bc25-2251dff31570.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b5-eb62-75ad-bc25-2251dff31570",
        "storage_key": "property/6767906449166975/019d08b5-eb62-75ad-bc25-2251dff31570.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJcSNIRdbkq4cR4_ppv_CgrCE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "truck_stop"
    },
    {
      "id": "custom_640bd03b-e8a4-41be-99ff-c77f72a95b79",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166975",
      "source": "custom",
      "poi_name": "Hutch's",
      "poi_type": "Transportation & Transit",
      "poi_address": "2000 S Main St, Elk City, OK 73644, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166975/019d08b5-89c1-70c8-8349-a847b648b11b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b5-89c1-70c8-8349-a847b648b11b",
        "storage_key": "property/6767906449166975/019d08b5-89c1-70c8-8349-a847b648b11b.webp",
        "width": 960,
        "height": 640
      },
      "poi_business_url": "https://www.hutchs.net/2000-south-main-street/?utm_source=google&utm_medium=local&utm_campaign=google-local",
      "poi_directions_map_url": "https://maps.google.com/?cid=10964616898016199469&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hutchs",
      "poi_latitude": "35.3926249",
      "poi_longitude": "-99.4040098",
      "poi_miles_from_property": "3.5",
      "poi_walking_minutes": "1 hour 17 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 580-225-3301",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166975/019d08b5-eb76-7673-a473-322c13c68793.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b5-eb76-7673-a473-322c13c68793",
        "storage_key": "property/6767906449166975/019d08b5-eb76-7673-a473-322c13c68793.webp",
        "width": 192,
        "height": 161
      },
      "poi_google_place_id": "ChIJQQEilnPlq4cRLUOAyPkkKpg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "convenience_store"
    },
    {
      "id": "custom_b880ad36-f3f3-4efc-a3d7-ddf8e71ad3ad",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166975",
      "source": "custom",
      "poi_name": "Walmart Supercenter",
      "poi_type": "Transportation & Transit",
      "poi_address": "210 Regional Dr, Elk City, OK 73644, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166975/019d08b5-8581-754b-8a69-8c800fdd6af0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b5-8581-754b-8a69-8c800fdd6af0",
        "storage_key": "property/6767906449166975/019d08b5-8581-754b-8a69-8c800fdd6af0.webp",
        "width": 1067,
        "height": 600
      },
      "poi_business_url": "https://www.walmart.com/store/134-elk-city-ok/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=13682067315935966193&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walmart-supercenter",
      "poi_latitude": "35.4092259",
      "poi_longitude": "-99.3764982",
      "poi_miles_from_property": "4.2",
      "poi_walking_minutes": "1 hour 33 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 580-225-3003",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166975/019d08b5-eb62-75ad-bc25-2251dff31570.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b5-eb62-75ad-bc25-2251dff31570",
        "storage_key": "property/6767906449166975/019d08b5-eb62-75ad-bc25-2251dff31570.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJVbfAHUEGsocR8XNYr7t34L0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_bd902c33-e7a8-47af-b5a4-211430da2a4a",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166975",
      "source": "custom",
      "poi_name": "Farmrail Corporation",
      "poi_type": "Transportation & Transit",
      "poi_address": "1601 W Gary Blvd, Clinton, OK 73601, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166975/019d08b5-d9fa-754c-a3eb-8aee34a0fff6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b5-d9fa-754c-a3eb-8aee34a0fff6",
        "storage_key": "property/6767906449166975/019d08b5-d9fa-754c-a3eb-8aee34a0fff6.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.farmrail.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17687405620974347365&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "farmrail-corporation",
      "poi_latitude": "35.5152609",
      "poi_longitude": "-98.9794321",
      "poi_miles_from_property": "30.2",
      "poi_walking_minutes": "10 hours 50 mins",
      "poi_biking_minutes": "2 hours 33 mins",
      "poi_driving_minutes": "32 mins",
      "poi_business_phone": "+1 580-323-4567",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166975/019d08b5-e667-73ac-9fec-ff53f91b1d73.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b5-e667-73ac-9fec-ff53f91b1d73",
        "storage_key": "property/6767906449166975/019d08b5-e667-73ac-9fec-ff53f91b1d73.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJscDRrPIcrIcRZWRsTLNJdvU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_30ba085e-3920-41f6-83c7-46a84f917d97",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166975",
      "source": "custom",
      "poi_name": "Elk City City Hall",
      "poi_type": "Major Employers & Offices",
      "poi_address": "320 W 3rd St, Elk City, OK 73644, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166975/019d08b5-d8d3-74c5-8fac-69bb555cf17d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b5-d8d3-74c5-8fac-69bb555cf17d",
        "storage_key": "property/6767906449166975/019d08b5-d8d3-74c5-8fac-69bb555cf17d.webp",
        "width": 1280,
        "height": 852
      },
      "poi_business_url": "http://www.elkcity.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12163949303985423824&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "elk-city-city-hall",
      "poi_latitude": "35.4110298",
      "poi_longitude": "-99.4081802",
      "poi_miles_from_property": "2.1",
      "poi_walking_minutes": "45 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 580-225-3230",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166975/019d08b5-f763-7078-942c-7f3e9f43e911.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b5-f763-7078-942c-7f3e9f43e911",
        "storage_key": "property/6767906449166975/019d08b5-f763-7078-942c-7f3e9f43e911.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJAQb4nwblq4cR0EXp0XEHz6g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "local_government_office"
    },
    {
      "id": "custom_055b9b9e-11f7-4f9f-8611-1315f112d7a7",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166975",
      "source": "custom",
      "poi_name": "Elk City Police Department",
      "poi_type": "Major Employers & Offices",
      "poi_address": "422 E 3rd St, Elk City, OK 73644, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://elkcity.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15693535911759071102&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "elk-city-police-department",
      "poi_latitude": "35.4112308",
      "poi_longitude": "-99.4000507",
      "poi_miles_from_property": "2.5",
      "poi_walking_minutes": "54 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 580-225-1212",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166975/019d08b5-f763-7078-942c-7f3e9f43e911.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b5-f763-7078-942c-7f3e9f43e911",
        "storage_key": "property/6767906449166975/019d08b5-f763-7078-942c-7f3e9f43e911.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJZSunSBvlq4cRfkc8isOjytk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "government_office"
    },
    {
      "id": "custom_e05530c1-3de2-4839-a6ba-02c1643f8003",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166975",
      "source": "custom",
      "poi_name": "Elk City Fire Department",
      "poi_type": "Major Employers & Offices",
      "poi_address": "403 W 5th St, Elk City, OK 73644, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166975/019d08b5-db88-71d7-b4fb-7dfbf3228899.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b5-db88-71d7-b4fb-7dfbf3228899",
        "storage_key": "property/6767906449166975/019d08b5-db88-71d7-b4fb-7dfbf3228899.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.elkcity.com/city-hall/departments/fire-department/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16223492038763388143&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "elk-city-fire-department",
      "poi_latitude": "35.409867",
      "poi_longitude": "-99.408651",
      "poi_miles_from_property": "2.1",
      "poi_walking_minutes": "46 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 580-225-0500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166975/019d08b5-f763-7078-942c-7f3e9f43e911.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b5-f763-7078-942c-7f3e9f43e911",
        "storage_key": "property/6767906449166975/019d08b5-f763-7078-942c-7f3e9f43e911.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJx01ajQblq4cR75zesg1sJeE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fire_station"
    },
    {
      "id": "custom_c0ed5701-7956-4a14-96ff-c8cd39dd3933",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166975",
      "source": "custom",
      "poi_name": "Elk City Schools Administration",
      "poi_type": "Major Employers & Offices",
      "poi_address": "300 N Boone Ave, Elk City, OK 73644, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://www.elkcityschools.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=523048044287010810&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "elk-city-schools-administration",
      "poi_latitude": "35.414287",
      "poi_longitude": "-99.4123481",
      "poi_miles_from_property": "1.6",
      "poi_walking_minutes": "33 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 580-225-0175",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166975/019d08b5-eb79-738e-8bd1-62af3faad494.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b5-eb79-738e-8bd1-62af3faad494",
        "storage_key": "property/6767906449166975/019d08b5-eb79-738e-8bd1-62af3faad494.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJVVqboQblq4cR-qcw0Gw9Qgc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_80e89104-e7ea-4fdd-987d-dbb1333c8fb0",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166975",
      "source": "custom",
      "poi_name": "Beckham County Health Department",
      "poi_type": "Major Employers & Offices",
      "poi_address": "400 E 3rd St, Elk City, OK 73644, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166975/019d08b5-dbd7-72a5-ae53-239320696b2c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b5-dbd7-72a5-ae53-239320696b2c",
        "storage_key": "property/6767906449166975/019d08b5-dbd7-72a5-ae53-239320696b2c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://beckham.health.ok.gov/",
      "poi_directions_map_url": "https://maps.google.com/?cid=637818174857490982&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "beckham-county-health-department",
      "poi_latitude": "35.4113166",
      "poi_longitude": "-99.4015702",
      "poi_miles_from_property": "2.4",
      "poi_walking_minutes": "51 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 580-225-1173",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166975/019d08b5-f763-7078-942c-7f3e9f43e911.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b5-f763-7078-942c-7f3e9f43e911",
        "storage_key": "property/6767906449166975/019d08b5-f763-7078-942c-7f3e9f43e911.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJrRD3pATlq4cRJjKrL0D82Qg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "health"
    },
    {
      "id": "custom_4672d38b-6ac3-4ffa-a3a6-572abfa2f767",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166975",
      "source": "custom",
      "poi_name": "United States Postal Service",
      "poi_type": "Major Employers & Offices",
      "poi_address": "101 S Adams Ave, Elk City, OK 73644, USA",
      "poi_short_description": "Post office offering standard mailing and shipping services, as well as money orders.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166975/019d08b5-e063-734c-9a07-be72332eda20.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b5-e063-734c-9a07-be72332eda20",
        "storage_key": "property/6767906449166975/019d08b5-e063-734c-9a07-be72332eda20.webp",
        "width": 720,
        "height": 730
      },
      "poi_business_url": "https://tools.usps.com/locations/details/1362299?utm_source=google-my-business-url&utm_medium=search&utm_campaign=yext",
      "poi_directions_map_url": "https://maps.google.com/?cid=16434881858389135973&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "united-states-postal-service",
      "poi_latitude": "35.4102346",
      "poi_longitude": "-99.4078857",
      "poi_miles_from_property": "2.1",
      "poi_walking_minutes": "46 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 800-275-8777",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166975/019d08b5-f763-7078-942c-7f3e9f43e911.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b5-f763-7078-942c-7f3e9f43e911",
        "storage_key": "property/6767906449166975/019d08b5-f763-7078-942c-7f3e9f43e911.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJTech6gblq4cRZdLLdvltFOQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "post_office"
    }
  ],
  "office_hours": [
    {
      "id": "custom_c101e020-0191-49e0-9b19-3236218a9a0d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166975",
      "day": "MON",
      "open_time": "08:00",
      "close_time": "17:00"
    },
    {
      "id": "custom_8c48c868-cf59-4df3-9dad-6c320dc8f054",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166975",
      "day": "TUE",
      "open_time": "08:00",
      "close_time": "17:00"
    },
    {
      "id": "custom_2855c5df-9013-4cef-a4ab-115b7a42621c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166975",
      "day": "WED",
      "open_time": "08:00",
      "close_time": "17:00"
    },
    {
      "id": "custom_25a1e307-a28e-48ad-a23e-af064a0ce614",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166975",
      "day": "THU",
      "open_time": "08:00",
      "close_time": "17:00"
    },
    {
      "id": "custom_17bc496a-7529-4759-a4ba-f2a63f50444d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166975",
      "day": "FRI",
      "open_time": "08:00",
      "close_time": "17:00"
    },
    {
      "id": "custom_86a0c36b-070a-4300-9f0c-4d3855d44ef8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166975",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "14:00"
    }
  ],
  "reviews": [
    {
      "id": "custom_4f743b64-b2b3-4841-88dc-3fd473655525",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166975",
      "rating": "5",
      "name": "Stephanie Lieu",
      "text": "Lived here for a year and a half and have had a great experience living here. I have lived in many apartment complexes and this has been my favorite and top experience so far. Management actually cares about the property and the residents enjoyability while living here. I've enjoyed all the residents events that they host.\n\nAnother plus is no valet trash and package lockers instead of fetch (apparently they did briefly go to fetch, but the residents hated it, so they listened and went back to lockers).\n\nI workout late and I see the security guard walking around the property every night. So they don't skimp on that either.\n\nJust read someone complained about water being out \"all\" the time. To be fair, it's not all the time, I think the 1.5 years I've been here, it's 6 times, with management giving as much notice as possible. The water outage is due to the apartment being built across the street, so it's but really their fault. Twice it was for maintenance.\n\nIf it wasn't for unforseen life circumstances, I would've renewed with this complex, no second thoughts. Management have been flexible in working with me to timing my move.\n\nI cannot recommend this complex enough, that is all.",
      "date": "2025-10-29",
      "title": "false"
    },
    {
      "id": "custom_f8e8f3c1-1f15-4766-9fc9-57041a175437",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166975",
      "rating": "5",
      "name": "Monica Hernandez",
      "text": "Great place to live!\nOne thing that I absolutely love about living here are the secured gates and garages! I feel happy knowing that my car is safe and that the hallways are safe from vandalism and harm. Where we lived before we saw people that did not belong to complex walking the halls stealing packages using our bathrooms and breaking into our cars. Sometimes I have to leave early in the morning before daybreak but I feel happy knowing I'm behind locked gates. This is very important to me since my car and my neighbors car have been broken into and damaged at another complex. Also this is a smoke free environment. This also means a lot to me since we have allergies and asthma. This is a definite plus for us! I have recommended Crestview to my friends and hope to see them soon.\nMonica and Frankie",
      "date": "2025-10-25",
      "title": "false"
    },
    {
      "id": "custom_d5a29875-5a36-4dfb-84db-840d3999c29e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166975",
      "rating": "5",
      "name": "Angie Abas",
      "text": "One thing that has really exceeded my expectations is how well maintained and peaceful the community is.\nThe management team is responsive and the environment feels safe and comfort---it truly feels like home.\nI appreciate the effort that goes into keeping everything running smoothly!",
      "date": "2025-10-29",
      "title": "false"
    },
    {
      "id": "custom_54805390-0de3-45d1-833f-a031f877e14d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166975",
      "rating": "5",
      "name": "Antonio Rios",
      "text": "I stayed at Crestview for one year and it was an awesome experience. The gym is incredible compared to most other apartment complexes. The hallways and outside look of the apartments is very clean and new. Anytime I had an issue in my apartment, the maintenance staff was quick to help fix and respond to my problems.\n\nThe leasing office staff had some of the best people I have ever had the pleasure of talking to. Katie, Victoria, and Ashley were all amazing and had a warm smile when greeting me and any other tenant. They always threw diverse monthly events that got people to meet up, drink, relax, and have fun. I highly recommend for anyone to live at Crestview Commons. If I ever move back to Austin, I will definitely come back and live there again.",
      "date": "2024-05-29",
      "title": "false"
    }
  ],
  "virtual_tours": [],
  "faqs": [],
  "fees": [],
  "pet_policies": [],
  "lead_collectors": [
    {
      "lead_collector_id": "019ba452-ee2e-75c9-89ea-e09ee70ad93b",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "rr-living-crestview-commons",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166975"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166975",
      "source": "generator",
      "page_item_url": "apartments-with-pool-elk-city-ok",
      "search_query": "apartments with pool in Elk City OK",
      "category": "Amenity",
      "h1_title": "Apartments with Pool in Elk City, OK",
      "h2_subtitle": "Explore modern living in Elk City, OK with our apartments. Enjoy amenities like a pool and chic interiors at Crestview Commons.",
      "page_copy": "Discover the perfect blend of comfort and style at Crestview Commons, offering modern apartments with a pool in Elk City, OK. Designed for relaxed living, our one and two-bedroom residences feature high ceilings and designer finishes that cater to your sophisticated taste. Unwind by our refreshing on-site pool, perfect for a leisurely weekend or after work relaxation. \n\nNestled in Elk City, OK, Crestview Commons boasts amenities like energy-efficient appliances, a breakfast bar, and smoke-free living, ensuring your home is as convenient as it is stylish. With on-site laundry facilities and maintenance, our community makes everyday living hassle-free. Schedule a tour today and take the first step towards finding your new home with a pool in Elk City.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166975/019fb451-dad7-722f-83df-3b13511622d8.webp",
      "featured_image_media": {
        "alt_text": "Exterior of a single-story building with light blue siding and brick accents.",
        "public_id": "019fb451-dad7-722f-83df-3b13511622d8",
        "storage_key": "property/6767906449166975/019fb451-dad7-722f-83df-3b13511622d8.webp",
        "width": 1280,
        "height": 853
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Pool in Elk City, OK",
      "seo_description": "Find stylish apartments with a pool in Elk City, OK at Crestview Commons. Enjoy modern living and desirable amenities in a convenient location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166975",
      "source": "generator",
      "page_item_url": "energy-efficient-apartments-beckham-county",
      "search_query": "energy efficient apartments Beckham County",
      "category": "Amenity",
      "h1_title": "Energy Efficient Apartments in Beckham County",
      "h2_subtitle": "Experience energy-efficient living in Beckham County. Discover modern design and eco-friendly amenities at Crestview Commons.",
      "page_copy": "Crestview Commons invites you to experience energy-efficient apartments in the heart of Beckham County. Our thoughtfully designed one and two-bedroom floor plans incorporate A/C & heat, energy-saving lighting, and windows, along with state-of-the-art appliances like microwaves, refrigerators, and dishwashers. Our focus on efficiency ensures you not only save on utilities but also contribute to a more sustainable environment. \n\nLocated in Elk City, OK, Crestview Commons blends efficiency with elegance, offering additional amenities such as a breakfast bar, modern designer finishes, and an inviting pool. Enjoy the convenience of laundry facilities and on-site maintenance, making your living experience as easy as it is stylish. Explore our energy-efficient community today and find a home that fits your lifestyle and values.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166975/019fb451-dad7-722f-83df-3b13511622d8.webp",
      "featured_image_media": {
        "alt_text": "Exterior of a single-story building with light blue siding and brick accents.",
        "public_id": "019fb451-dad7-722f-83df-3b13511622d8",
        "storage_key": "property/6767906449166975/019fb451-dad7-722f-83df-3b13511622d8.webp",
        "width": 1280,
        "height": 853
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Energy Efficient Apartments in Beckham County",
      "seo_description": "Discover energy-efficient apartments in Beckham County at Crestview Commons. Enjoy modern amenities and eco-friendly living in Elk City, OK.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166975",
      "source": "generator",
      "page_item_url": "smoke-free-apartments-near-73644",
      "search_query": "smoke-free apartments near 73644",
      "category": "Amenity",
      "h1_title": "Smoke-Free Apartments Near 73644",
      "h2_subtitle": "Enjoy smoke-free living near 73644 in Elk City, OK. Discover Crestview Commons, a community focused on healthy lifestyles.",
      "page_copy": "Discover a healthier living environment with smoke-free apartments at Crestview Commons, conveniently located near the 73644 area in Elk City, OK. Our community prioritizes your well-being and comfort, offering one and two-bedroom floor plans designed with modern features and finishes that create a sophisticated lifestyle. Enjoy amenities like a refreshing pool and energy-efficient appliances in a smoke-free setting.\n\nAt Crestview Commons, our commitment to providing a healthy, smoke-free environment complements our chic interiors and practical amenities. Residents benefit from on-site laundry facilities, a breakfast bar, and professional maintenance services, making everyday life more convenient and enjoyable. Choose a home that supports your wellness goals in a thriving community today by visiting Crestview Commons.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166975/019fb451-dad7-722f-83df-3b13511622d8.webp",
      "featured_image_media": {
        "alt_text": "Exterior of a single-story building with light blue siding and brick accents.",
        "public_id": "019fb451-dad7-722f-83df-3b13511622d8",
        "storage_key": "property/6767906449166975/019fb451-dad7-722f-83df-3b13511622d8.webp",
        "width": 1280,
        "height": 853
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Smoke-Free Apartments Near 73644",
      "seo_description": "Explore smoke-free apartments near 73644 at Crestview Commons in Elk City, OK. Enjoy a healthy lifestyle with modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166975",
      "source": "generator",
      "page_item_url": "designer-finishes-elk-city-apartments",
      "search_query": "designer finishes in Elk City apartments",
      "category": "Amenity",
      "h1_title": "Designer Finishes in Elk City Apartments",
      "h2_subtitle": "Discover Elk City apartments with stunning designer finishes. Crestview Commons offers a modern living experience like no other.",
      "page_copy": "At Crestview Commons, experience Elk City apartments that boast exquisite designer finishes tailored for modern living. Our one and two-bedroom floor plans feature high ceilings and refined touches that set your home apart. Whether it's the sophisticated detailing in the finishes or the contemporary ambiance created through thoughtful design, our residences reflect both style and functionality.\n\nCentrally located in Elk City, Crestview Commons not only offers stylish interiors but also convenience and comfort. With amenities such as energy-efficient appliances, a chic breakfast bar, and a refreshing pool, our community is designed for your lifestyle. Embrace the best in Elk City living by choosing an apartment where designer finishes elevate your everyday experience.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166975/019fb451-dad7-722f-83df-3b13511622d8.webp",
      "featured_image_media": {
        "alt_text": "Exterior of a single-story building with light blue siding and brick accents.",
        "public_id": "019fb451-dad7-722f-83df-3b13511622d8",
        "storage_key": "property/6767906449166975/019fb451-dad7-722f-83df-3b13511622d8.webp",
        "width": 1280,
        "height": 853
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Designer Finishes in Elk City Apartments",
      "seo_description": "Find Elk City apartments with designer finishes at Crestview Commons. Experience modern living with stunning interiors and amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166975",
      "source": "generator",
      "page_item_url": "high-speed-internet-cable-ready-apartments-ok",
      "search_query": "high-speed internet and cable ready apartments OK",
      "category": "Amenity",
      "h1_title": "High-Speed Internet and Cable Apartments OK",
      "h2_subtitle": "Find apartments equipped with high-speed internet and cable in OK. Enjoy modern conveniences at Crestview Commons.",
      "page_copy": "Experience seamless connectivity at Crestview Commons, where our Oklahoma apartments are prepped with high-speed internet and cable readiness. This setup ensures you're always online and entertained, catering to both professional needs and lifestyle preferences. Our Elk City community offers spacious one and two-bedroom floor plans, built with modern living in mind.\n\nAlongside cutting-edge connectivity, enjoy a myriad of amenities such as energy-efficient appliances, a vibrant pool, and chic designer finishes. Located conveniently in Elk City, OK, Crestview Commons promises a lifestyle that balances technology and comfort effortlessly. Discover an apartment where high-speed internet and cable-ready conveniences merge with elegant living spaces tailored just for you.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166975/019fb451-dad7-722f-83df-3b13511622d8.webp",
      "featured_image_media": {
        "alt_text": "Exterior of a single-story building with light blue siding and brick accents.",
        "public_id": "019fb451-dad7-722f-83df-3b13511622d8",
        "storage_key": "property/6767906449166975/019fb451-dad7-722f-83df-3b13511622d8.webp",
        "width": 1280,
        "height": 853
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "High-Speed Internet & Cable Apartments in OK",
      "seo_description": "Explore high-speed internet and cable-ready apartments in OK at Crestview Commons. Enjoy seamless connectivity and modern living in Elk City.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166975",
      "source": "generator",
      "page_item_url": "one-bedroom-apartments-elk-city-ok",
      "search_query": "one bedroom apartments elk city ok",
      "category": "Floorplan",
      "h1_title": "One Bedroom Apartments in Elk City, OK",
      "h2_subtitle": "Discover the perfect one-bedroom apartment in Elk City, OK at Crestview Commons. Modern amenities await you!",
      "page_copy": "Explore the ideal one-bedroom apartments in Elk City, OK at Crestview Commons. Designed for modern living, our one-bedroom floor plans feature spacious layouts and sophisticated interiors with designer finishes. The apartments are equipped with energy-efficient appliances, ensuring a comfortable and sustainable living experience.\n\nCrestview Commons offers a vibrant community atmosphere with amenities that include a refreshing pool and convenient laundry facilities. Nestled in the heart of Elk City, our one-bedroom apartments combine style, convenience, and modern comforts. Whether you're moving to the area or looking to upgrade, Crestview Commons provides the perfect setting for your lifestyle in Elk City, OK.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166975/019fb451-dad7-722f-83df-3b13511622d8.webp",
      "featured_image_media": {
        "alt_text": "Exterior of a single-story building with light blue siding and brick accents.",
        "public_id": "019fb451-dad7-722f-83df-3b13511622d8",
        "storage_key": "property/6767906449166975/019fb451-dad7-722f-83df-3b13511622d8.webp",
        "width": 1280,
        "height": 853
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "One Bedroom Apartments in Elk City, OK",
      "seo_description": "Find your perfect one-bedroom apartment in Elk City, OK at Crestview Commons. Enjoy modern amenities and designer finishes.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166975",
      "source": "generator",
      "page_item_url": "two-bedroom-apartment-beckham-county",
      "search_query": "two bedroom apartment beckham county",
      "category": "Floorplan",
      "h1_title": "Two Bedroom Apartments in Beckham County",
      "h2_subtitle": "Explore two-bedroom apartments in Beckham County at Crestview Commons. Experience spacious comfort and modern amenities.",
      "page_copy": "Discover the epitome of modern living with our two-bedroom apartments in Beckham County at Crestview Commons. These thoughtfully designed residences provide ample space and feature high ceilings, offering a sense of openness and comfort. Each two-bedroom apartment comes with designer finishes that enhance your living experience, creating a stylish and inviting atmosphere.\n\nLocated in Elk City, our community is a haven of convenience and leisure, offering a pool and energy-efficient appliances. Crestview Commons is the ideal choice for individuals or families seeking spacious accommodations in Beckham County. With amenities that support a balanced lifestyle, our two-bedroom apartments offer everything you need to call Elk City your home.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166975/019fb451-dad7-722f-83df-3b13511622d8.webp",
      "featured_image_media": {
        "alt_text": "Exterior of a single-story building with light blue siding and brick accents.",
        "public_id": "019fb451-dad7-722f-83df-3b13511622d8",
        "storage_key": "property/6767906449166975/019fb451-dad7-722f-83df-3b13511622d8.webp",
        "width": 1280,
        "height": 853
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Two Bedroom Apartments Beckham County",
      "seo_description": "Explore modern two-bedroom apartments in Beckham County at Crestview Commons. Enjoy spacious living and premium amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166975",
      "source": "generator",
      "page_item_url": "apartments-near-elk-city-intermediate-school",
      "search_query": "apartments near elk city intermediate school elk city",
      "category": "School",
      "h1_title": "Apartments Near Elk City Intermediate School",
      "h2_subtitle": "Find convenient apartments near Elk City Intermediate School. Crestview Commons offers ideal living options close by.",
      "page_copy": "If you're looking for apartments near Elk City Intermediate School, Crestview Commons provides the perfect location. Situated just a short distance from the school, our community ensures that daily commutes are hassle-free, allowing more time for the things that matter. Our apartments feature one and two-bedroom layouts equipped with modern amenities and stylish finishes.\n\nAt Crestview Commons, you’ll find a living space that caters to modern lifestyles, complete with energy-efficient appliances and a refreshing pool. This Elk City community combines convenience and comfort, making it an excellent choice for those prioritizing proximity to local schools and an elevated living experience.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166975/019fb451-dad7-722f-83df-3b13511622d8.webp",
      "featured_image_media": {
        "alt_text": "Exterior of a single-story building with light blue siding and brick accents.",
        "public_id": "019fb451-dad7-722f-83df-3b13511622d8",
        "storage_key": "property/6767906449166975/019fb451-dad7-722f-83df-3b13511622d8.webp",
        "width": 1280,
        "height": 853
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apts Near Elk City Intermediate School",
      "seo_description": "Discover apartments near Elk City Intermediate School at Crestview Commons. Enjoy convenient living with modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166975",
      "source": "generator",
      "page_item_url": "crestview-commons-near-elk-city-high-school",
      "search_query": "crestview commons near elk city high school",
      "category": "School",
      "h1_title": "Crestview Commons by Elk City High School",
      "h2_subtitle": "Crestview Commons offers ideal apartments near Elk City High School. Discover comfortable and convenient living.",
      "page_copy": "Crestview Commons is excellently located near Elk City High School, making it an ideal choice for families and students seeking convenience along with comfort. Our modern community features a range of one and two-bedroom apartments that provide spacious layouts and elegant finishes, perfect for anyone looking to make Elk City their home.\n\nEnjoy the benefits of living close to Elk City High School while indulging in top-tier amenities such as a refreshing pool and energy-efficient appliances at Crestview Commons. Whether you're heading out to school or settling in for a relaxing evening at home, our Elk City apartments offer a perfect balance of accessibility and luxury.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166975/019fb451-dad7-722f-83df-3b13511622d8.webp",
      "featured_image_media": {
        "alt_text": "Exterior of a single-story building with light blue siding and brick accents.",
        "public_id": "019fb451-dad7-722f-83df-3b13511622d8",
        "storage_key": "property/6767906449166975/019fb451-dad7-722f-83df-3b13511622d8.webp",
        "width": 1280,
        "height": 853
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Crestview Commons by Elk City High",
      "seo_description": "Live near Elk City High School at Crestview Commons. Enjoy modern apartments with convenient access and premium amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166975",
      "source": "generator",
      "page_item_url": "elk-city-middle-school-nearby-apartments",
      "search_query": "elk city middle school nearby apartments",
      "category": "School",
      "h1_title": "Nearby Apartments to Elk City Middle School",
      "h2_subtitle": "Discover convenient living with apartments near Elk City Middle School. Experience community and modern comfort at Crestview Commons.",
      "page_copy": "Nestled close to Elk City Middle School, Crestview Commons offers the perfect living solution for families and individuals who prioritize proximity to educational institutions. Our community boasts sophisticated one and two-bedroom apartments equipped with designer finishes, ensuring a stylish yet comfortable lifestyle.\n\nLiving at Crestview Commons not only means being steps away from Elk City Middle School but also enjoying access to premium amenities such as a refreshing pool and energy-efficient appliances. Our Elk City apartments are designed to cater to modern living needs, providing an ideal mix of convenience, luxury, and community spirit.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166975/019fb451-dad7-722f-83df-3b13511622d8.webp",
      "featured_image_media": {
        "alt_text": "Exterior of a single-story building with light blue siding and brick accents.",
        "public_id": "019fb451-dad7-722f-83df-3b13511622d8",
        "storage_key": "property/6767906449166975/019fb451-dad7-722f-83df-3b13511622d8.webp",
        "width": 1280,
        "height": 853
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Elk City Middle School",
      "seo_description": "Explore beautiful apartments near Elk City Middle School at Crestview Commons. Enjoy modern amenities and convenient location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166975",
      "source": "generator",
      "page_item_url": "elk-city-intermediate-school-vicinity-apartments",
      "search_query": "elk city intermediate school vicinity apartments",
      "category": "School",
      "h1_title": "Apartments in Elk City Intermediate School Vicinity",
      "h2_subtitle": "Find apartments conveniently located in the vicinity of Elk City Intermediate School. Enjoy quality living at Crestview Commons.",
      "page_copy": "Crestview Commons offers a prime location for those seeking apartments in the vicinity of Elk City Intermediate School. Our community is tailored for comfort and accessibility, making it an excellent choice for families and individuals desiring swift commutes. Our spacious one and two-bedroom apartment layouts are enhanced with modern finishes, creating an inviting and stylish living atmosphere.\n\nLiving near Elk City Intermediate School at Crestview Commons means enjoying the best of Elk City living with high-end amenities like energy-efficient appliances and a sparkling pool. This prime location ensures you’re never far from educational opportunities while enjoying a relaxed and luxurious lifestyle.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166975/019fb451-dad7-722f-83df-3b13511622d8.webp",
      "featured_image_media": {
        "alt_text": "Exterior of a single-story building with light blue siding and brick accents.",
        "public_id": "019fb451-dad7-722f-83df-3b13511622d8",
        "storage_key": "property/6767906449166975/019fb451-dad7-722f-83df-3b13511622d8.webp",
        "width": 1280,
        "height": 853
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Elk City Intermediate School Vicinity Apts",
      "seo_description": "Live near Elk City Intermediate School at Crestview Commons. Discover convenient apartments with modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166975",
      "source": "generator",
      "page_item_url": "fairview-elementary-school-apartments-elk-city",
      "search_query": "fairview elementary school apartments elk city",
      "category": "School",
      "h1_title": "Apartments Near Fairview Elementary, Elk City",
      "h2_subtitle": "Explore apartments near Fairview Elementary School in Elk City. Experience convenience and modern living at Crestview Commons.",
      "page_copy": "Crestview Commons is the perfect choice for those looking for apartments near Fairview Elementary School in Elk City. Our community offers stylish one and two-bedroom apartments designed to provide both comfort and convenience, making it an ideal destination for families and educators alike.\n\nLocated just a short distance from Fairview Elementary School, living at Crestview Commons means easy access to quality education and modern amenities, including a refreshing pool and energy-efficient appliances. Enjoy the benefits of living in a community that balances educational proximity with upscale living in heart of Elk City.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166975/019fb451-dad7-722f-83df-3b13511622d8.webp",
      "featured_image_media": {
        "alt_text": "Exterior of a single-story building with light blue siding and brick accents.",
        "public_id": "019fb451-dad7-722f-83df-3b13511622d8",
        "storage_key": "property/6767906449166975/019fb451-dad7-722f-83df-3b13511622d8.webp",
        "width": 1280,
        "height": 853
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apts Near Fairview Elementary, Elk City",
      "seo_description": "Discover Elk City apartments near Fairview Elementary School at Crestview Commons. Enjoy modern amenities and convenient living.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166975",
      "source": "generator",
      "page_item_url": "western-oklahoma-christian-school-close-apartments",
      "search_query": "western oklahoma christian school close apartments",
      "category": "School",
      "h1_title": "Close Apartments to Western Oklahoma Christian School",
      "h2_subtitle": "Find apartments close to Western Oklahoma Christian School in Elk City. Embrace modern living at Crestview Commons.",
      "page_copy": "Crestview Commons offers an ideal living arrangement for those seeking apartments in close proximity to Western Oklahoma Christian School. Our community features contemporary one and two-bedroom apartments with high-end finishes, perfect for families and individuals who value convenience.\n\nBeing near Western Oklahoma Christian School, residents at Crestview Commons benefit from a location that provides easy access to educational facilities while enjoying amenities like a pristine pool and state-of-the-art, energy-efficient appliances. Experience the harmony of modern comfort and educational convenience right in Elk City.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166975/019fb451-dad7-722f-83df-3b13511622d8.webp",
      "featured_image_media": {
        "alt_text": "Exterior of a single-story building with light blue siding and brick accents.",
        "public_id": "019fb451-dad7-722f-83df-3b13511622d8",
        "storage_key": "property/6767906449166975/019fb451-dad7-722f-83df-3b13511622d8.webp",
        "width": 1280,
        "height": 853
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apts Close to Western OK Christian School",
      "seo_description": "Live close to Western Oklahoma Christian School at Crestview Commons. Enjoy modern, convenient apartment living in Elk City.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166975",
      "source": "generator",
      "page_item_url": "apartments-near-great-plains-regional-medical-center",
      "search_query": "apartments near Great Plains Regional Medical Center Elk City",
      "category": "Hospital",
      "h1_title": "Apartments Near Great Plains Medical Center",
      "h2_subtitle": "Discover convenient living near Great Plains Regional Medical Center in Elk City. Crestview Commons offers modern amenities and comfort.",
      "page_copy": "Crestview Commons is your go-to community for apartments near Great Plains Regional Medical Center in Elk City. Our stylish one and two-bedroom floor plans are perfect for healthcare professionals and patients seeking comfort and convenience close to their place of caregiving and healing.\n\nLocated a short distance from the medical center, Crestview Commons ensures that residents enjoy a quick and hassle-free commute while having modern amenities at their disposal. From energy-efficient appliances to a refreshing pool, experience a balanced lifestyle that combines proximity with luxury living in Elk City.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166975/019fb451-dad7-722f-83df-3b13511622d8.webp",
      "featured_image_media": {
        "alt_text": "Exterior of a single-story building with light blue siding and brick accents.",
        "public_id": "019fb451-dad7-722f-83df-3b13511622d8",
        "storage_key": "property/6767906449166975/019fb451-dad7-722f-83df-3b13511622d8.webp",
        "width": 1280,
        "height": 853
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apts Near Great Plains Medical Center Elk City",
      "seo_description": "Discover Elk City apartments close to Great Plains Regional Medical Center. Enjoy modern comforts and quick commutes at Crestview Commons.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166975",
      "source": "generator",
      "page_item_url": "apartments-near-colonel-herring-park-elk-city",
      "search_query": "apartments near Colonel Herring Park Elk City",
      "category": "Park",
      "h1_title": "Apartments Near Colonel Herring Park",
      "h2_subtitle": "Explore living options near Colonel Herring Park in Elk City. Crestview Commons offers convenience with modern lifestyle amenities.",
      "page_copy": "For those searching for apartments near Colonel Herring Park in Elk City, Crestview Commons stands out as a top choice. Our chic one and two-bedroom layouts are ideal for park lovers wanting easy access to outdoor recreation and modern in-home comforts.\n\nSituated close to Colonel Herring Park, Crestview Commons allows residents to enjoy leisurely strolls, picnics, and outdoor activities while also taking advantage of our amenities, such as a designer pool and energy-efficient features. Experience the fusion of urban convenience and natural beauty right in Elk City.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166975/019fb451-dad7-722f-83df-3b13511622d8.webp",
      "featured_image_media": {
        "alt_text": "Exterior of a single-story building with light blue siding and brick accents.",
        "public_id": "019fb451-dad7-722f-83df-3b13511622d8",
        "storage_key": "property/6767906449166975/019fb451-dad7-722f-83df-3b13511622d8.webp",
        "width": 1280,
        "height": 853
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apts Near Colonel Herring Park Elk City",
      "seo_description": "Find Elk City apartments close to Colonel Herring Park at Crestview Commons. Enjoy nearby outdoor spaces and modern living.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166975",
      "source": "generator",
      "page_item_url": "apartments-close-to-ackley-park-elk-city",
      "search_query": "apartments close to Ackley Park Elk City",
      "category": "Park",
      "h1_title": "Apartments Close to Ackley Park",
      "h2_subtitle": "Live near Ackley Park in Elk City while enjoying the modern comforts of Crestview Commons apartments, where convenience meets lifestyle.",
      "page_copy": "Crestview Commons is perfectly situated for those looking for apartments close to Ackley Park in Elk City. Our chic one and two-bedroom apartments provide not only modern amenities but also easy access to the natural beauty and recreational options at Ackley Park.\n\nWhether you're spending a leisurely day in the park or relaxing by our pool, Crestview Commons offers a lifestyle that balances outdoor enjoyment with comfortable living. With energy-efficient appliances and designer finishes, our residents enjoy the best of Elk City's offerings right at their doorstep.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166975/019fb451-dad7-722f-83df-3b13511622d8.webp",
      "featured_image_media": {
        "alt_text": "Exterior of a single-story building with light blue siding and brick accents.",
        "public_id": "019fb451-dad7-722f-83df-3b13511622d8",
        "storage_key": "property/6767906449166975/019fb451-dad7-722f-83df-3b13511622d8.webp",
        "width": 1280,
        "height": 853
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apts Close to Ackley Park Elk City",
      "seo_description": "Discover Crestview Commons apartments near Ackley Park in Elk City. Experience modern living close to outdoor leisure activities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166975",
      "source": "generator",
      "page_item_url": "crestview-commons-apartments-near-jaycee-park-ok",
      "search_query": "Crestview Commons apartments near Jaycee Park OK",
      "category": "Park",
      "h1_title": "Crestview Commons Near Jaycee Park",
      "h2_subtitle": "Experience Crestview Commons' modern living just moments away from Jaycee Park in Elk City, OK. Enjoy nearby nature and contemporary comforts.",
      "page_copy": "Discover a vibrant community at Crestview Commons, located conveniently near Jaycee Park in Elk City, OK. Our one and two-bedroom apartments are perfect for those who appreciate the blend of modern living with easy access to green spaces.\n\nJust a short walk from Jaycee Park, Crestview Commons provides residents with a unique combination of outdoor enjoyment and stylish home features. With a refreshing pool, on-site maintenance, and energy-saving appliances, you can enjoy all the amenities you desire while being connected to the natural beauty of Elk City.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166975/019fb451-dad7-722f-83df-3b13511622d8.webp",
      "featured_image_media": {
        "alt_text": "Exterior of a single-story building with light blue siding and brick accents.",
        "public_id": "019fb451-dad7-722f-83df-3b13511622d8",
        "storage_key": "property/6767906449166975/019fb451-dad7-722f-83df-3b13511622d8.webp",
        "width": 1280,
        "height": 853
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Crestview Commons Near Jaycee Park Elk City",
      "seo_description": "Find Crestview Commons apartments near Jaycee Park in Elk City, OK. Enjoy proximity to nature and modern living amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166975",
      "source": "generator",
      "page_item_url": "apartments-by-kiwanis-park-elk-city",
      "search_query": "apartments by Kiwanis Park Elk City",
      "category": "Park",
      "h1_title": "Apartments by Kiwanis Park",
      "h2_subtitle": "Live just steps from Kiwanis Park in Elk City. Crestview Commons offers modern apartment living right near this local favorite.",
      "page_copy": "Crestview Commons offers an exceptional living experience with its prime location close to Kiwanis Park in Elk City. Our one and two-bedroom apartments provide residents with a perfect balance of contemporary amenities and easy access to lovely outdoor spaces.\n\nEnjoy the scenic views and recreational opportunities that Kiwanis Park has to offer, all while indulging in the modern comforts of Crestview Commons. From designer finishes to energy-efficient features, our community ensures a high-quality living experience right by one of Elk City's best parks.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166975/019fb451-dad7-722f-83df-3b13511622d8.webp",
      "featured_image_media": {
        "alt_text": "Exterior of a single-story building with light blue siding and brick accents.",
        "public_id": "019fb451-dad7-722f-83df-3b13511622d8",
        "storage_key": "property/6767906449166975/019fb451-dad7-722f-83df-3b13511622d8.webp",
        "width": 1280,
        "height": 853
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apts by Kiwanis Park Elk City",
      "seo_description": "Discover Crestview Commons apartments near Kiwanis Park, Elk City, combining modern living with easy park access.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166975",
      "source": "generator",
      "page_item_url": "crestview-commons-near-ackley-park-ok",
      "search_query": "Crestview Commons near Ackley Park OK",
      "category": "Park",
      "h1_title": "Crestview Commons Near Ackley Park",
      "h2_subtitle": "Explore Crestview Commons, ideally situated near Ackley Park in Elk City, OK. Enjoy modern living close to this vibrant park.",
      "page_copy": "Discover the ideal combination of convenience and style at Crestview Commons, located just moments from the popular Ackley Park in Elk City, OK. Our residents enjoy access to fun-filled park activities while living in modern, well-equipped apartments.\n\nCrestview Commons offers spacious one and two-bedroom floor plans with high ceilings, designer finishes, and energy-efficient amenities. Whether you're relaxing by our pool or heading out for a picnic in the park, Crestview Commons is the perfect place to call home near Ackley Park.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166975/019fb451-dad7-722f-83df-3b13511622d8.webp",
      "featured_image_media": {
        "alt_text": "Exterior of a single-story building with light blue siding and brick accents.",
        "public_id": "019fb451-dad7-722f-83df-3b13511622d8",
        "storage_key": "property/6767906449166975/019fb451-dad7-722f-83df-3b13511622d8.webp",
        "width": 1280,
        "height": 853
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Crestview Commons Near Ackley Park OK",
      "seo_description": "Crestview Commons is near Ackley Park, Elk City, offering modern living with close access to outdoor fun and relaxation.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166975",
      "source": "generator",
      "page_item_url": "apartments-elk-city-near-ackley-park-west",
      "search_query": "apartments in Elk City near Ackley Park West",
      "category": "Park",
      "h1_title": "Apartments Near Ackley Park West",
      "h2_subtitle": "Find your ideal apartment in Elk City near Ackley Park West. Enjoy modern living at Crestview Commons with convenient park access.",
      "page_copy": "Crestview Commons is your destination for stylish living in Elk City, located conveniently close to Ackley Park West. Our one and two-bedroom apartments offer you the best of both worlds: cutting-edge amenities and the tranquility of nearby nature.\n\nExperience life with designer-selected finishes and energy-efficient features, all while being a stone's throw away from the vibrant Ackley Park West. Whether you enjoy a peaceful stroll or a day filled with activities, Crestview Commons provides the perfect home base for park enthusiasts.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166975/019fb451-dad7-722f-83df-3b13511622d8.webp",
      "featured_image_media": {
        "alt_text": "Exterior of a single-story building with light blue siding and brick accents.",
        "public_id": "019fb451-dad7-722f-83df-3b13511622d8",
        "storage_key": "property/6767906449166975/019fb451-dad7-722f-83df-3b13511622d8.webp",
        "width": 1280,
        "height": 853
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apts in Elk City Near Ackley Park West",
      "seo_description": "Find stylish apartments at Crestview Commons in Elk City, ideally located near Ackley Park West with modern amenities and park access.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "cameron@repli360.com"
    },
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "5824"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "10636273150"
    },
    {
      "ID": "custom_realpage_id",
      "type": "STRING",
      "value": "5599107"
    },
    {
      "ID": "custom_knock_a_link",
      "type": "STRING",
      "value": "https://www.crestviewcommonsapts.com?utm_knock=a"
    },
    {
      "ID": "custom_knock_g_link",
      "type": "STRING",
      "value": "https://www.crestviewcommonsapts.com?utm_knock=g"
    },
    {
      "ID": "custom_knock_r_link",
      "type": "STRING",
      "value": "https://www.crestviewcommonsapts.com?utm_knock=r"
    },
    {
      "ID": "custom_knock_w_link",
      "type": "STRING",
      "value": "https://www.crestviewcommonsapts.com?utm_knock=w"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-KT3WZDDR"
    },
    {
      "ID": "custom_knock_a_title",
      "type": "STRING",
      "value": "Apartments.com"
    },
    {
      "ID": "custom_knock_cl_link",
      "type": "STRING",
      "value": "https://www.crestviewcommonsapts.com?utm_knock=cl"
    },
    {
      "ID": "custom_knock_fb_link",
      "type": "STRING",
      "value": "https://www.crestviewcommonsapts.com?utm_knock=fb"
    },
    {
      "ID": "custom_knock_fl_link",
      "type": "STRING",
      "value": "https://www.crestviewcommonsapts.com?utm_knock=fl"
    },
    {
      "ID": "custom_knock_fr_link",
      "type": "STRING",
      "value": "https://www.crestviewcommonsapts.com?utm_knock=fr"
    },
    {
      "ID": "custom_knock_g_title",
      "type": "STRING",
      "value": "Google"
    },
    {
      "ID": "custom_knock_gp_link",
      "type": "STRING",
      "value": "https://www.crestviewcommonsapts.com?utm_knock=gp"
    },
    {
      "ID": "custom_knock_r_title",
      "type": "STRING",
      "value": "Rent.com"
    },
    {
      "ID": "custom_knock_w_title",
      "type": "STRING",
      "value": "Property Website"
    },
    {
      "ID": "custom_knock_a_number",
      "type": "STRING",
      "value": "580-325-3959"
    },
    {
      "ID": "custom_knock_ads_link",
      "type": "STRING",
      "value": "https://www.crestviewcommonsapts.com?utm_knock=ads"
    },
    {
      "ID": "custom_knock_cl_title",
      "type": "STRING",
      "value": "Craigslist"
    },
    {
      "ID": "custom_knock_fb_title",
      "type": "STRING",
      "value": "Facebook"
    },
    {
      "ID": "custom_knock_fl_title",
      "type": "STRING",
      "value": "Flag"
    },
    {
      "ID": "custom_knock_fr_title",
      "type": "STRING",
      "value": "ForRent"
    },
    {
      "ID": "custom_knock_g_number",
      "type": "STRING",
      "value": "580-238-5704"
    },
    {
      "ID": "custom_knock_gp_title",
      "type": "STRING",
      "value": "Google (paid)"
    },
    {
      "ID": "custom_knock_lcs_link",
      "type": "STRING",
      "value": "https://www.crestviewcommonsapts.com?utm_knock=lcs"
    },
    {
      "ID": "custom_knock_lgp_link",
      "type": "STRING",
      "value": "https://www.crestviewcommonsapts.com?utm_knock=lgp"
    },
    {
      "ID": "custom_knock_ppn_link",
      "type": "STRING",
      "value": "https://www.crestviewcommonsapts.com?utm_knock=ppn"
    },
    {
      "ID": "custom_knock_psa_link",
      "type": "STRING",
      "value": "https://www.crestviewcommonsapts.com?utm_knock=psa"
    },
    {
      "ID": "custom_knock_r_number",
      "type": "STRING",
      "value": "580-741-3098"
    },
    {
      "ID": "custom_knock_w_number",
      "type": "STRING",
      "value": "580-789-2906"
    },
    {
      "ID": "custom_knock_ads_title",
      "type": "STRING",
      "value": "META Social Ads"
    },
    {
      "ID": "custom_knock_cl_number",
      "type": "STRING",
      "value": "580-263-7256"
    },
    {
      "ID": "custom_knock_fb_number",
      "type": "STRING",
      "value": "580-309-5064"
    },
    {
      "ID": "custom_knock_fl_number",
      "type": "STRING",
      "value": "580-217-7274"
    },
    {
      "ID": "custom_knock_fr_number",
      "type": "STRING",
      "value": "580-263-7590"
    },
    {
      "ID": "custom_knock_gp_number",
      "type": "STRING",
      "value": "580-316-5445"
    },
    {
      "ID": "custom_knock_lcs_title",
      "type": "STRING",
      "value": "Local Search"
    },
    {
      "ID": "custom_knock_lgp_title",
      "type": "STRING",
      "value": "LE Google Performance Max"
    },
    {
      "ID": "custom_knock_osoc_link",
      "type": "STRING",
      "value": "https://www.crestviewcommonsapts.com?utm_knock=osoc"
    },
    {
      "ID": "custom_knock_ppn_title",
      "type": "STRING",
      "value": "Property Phone Number"
    },
    {
      "ID": "custom_knock_psa_title",
      "type": "STRING",
      "value": "Paid Social Ads"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_knock_ads_number",
      "type": "STRING",
      "value": "580-238-2690"
    },
    {
      "ID": "custom_knock_bcard_link",
      "type": "STRING",
      "value": "https://www.crestviewcommonsapts.com?utm_knock=bcard"
    },
    {
      "ID": "custom_knock_cfres_link",
      "type": "STRING",
      "value": "https://www.crestviewcommonsapts.com?utm_knock=cfres"
    },
    {
      "ID": "custom_knock_company_id",
      "type": "STRING",
      "value": "2416"
    },
    {
      "ID": "custom_knock_lcs_number",
      "type": "STRING",
      "value": "580-324-0858"
    },
    {
      "ID": "custom_knock_lgp_number",
      "type": "STRING",
      "value": "580-403-5454"
    },
    {
      "ID": "custom_knock_osoc_title",
      "type": "STRING",
      "value": "Organic Social"
    },
    {
      "ID": "custom_knock_ppcnk_link",
      "type": "STRING",
      "value": "https://www.crestviewcommonsapts.com?utm_knock=ppcnk"
    },
    {
      "ID": "custom_knock_ppn_number",
      "type": "STRING",
      "value": "580-633-3722"
    },
    {
      "ID": "custom_knock_psa_number",
      "type": "STRING",
      "value": "580-741-3327"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "full_stack"
    },
    {
      "ID": "custom_knock_bcard_title",
      "type": "STRING",
      "value": "Business Card"
    },
    {
      "ID": "custom_knock_cfres_title",
      "type": "STRING",
      "value": "Corporate Website"
    },
    {
      "ID": "custom_knock_flyers_link",
      "type": "STRING",
      "value": "https://www.crestviewcommonsapts.com?utm_knock=flyers"
    },
    {
      "ID": "custom_knock_osoc_number",
      "type": "STRING",
      "value": "580-219-4983"
    },
    {
      "ID": "custom_knock_ppcnk_title",
      "type": "STRING",
      "value": "PPC - Nonbrand Keywords"
    },
    {
      "ID": "custom_pet_screening_url",
      "type": "STRING",
      "value": "https://app.petscreening.com/"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "45778902314"
    },
    {
      "ID": "custom_knock_bcard_number",
      "type": "STRING",
      "value": "580-633-7130"
    },
    {
      "ID": "custom_knock_cfres_number",
      "type": "STRING",
      "value": "580-896-4441"
    },
    {
      "ID": "custom_knock_chatgpt_link",
      "type": "STRING",
      "value": "https://www.crestviewcommonsapts.com?utm_knock=CHATGPT"
    },
    {
      "ID": "custom_knock_community_id",
      "type": "STRING",
      "value": "1f0f1a2b47afb9e1"
    },
    {
      "ID": "custom_knock_dirmail_link",
      "type": "STRING",
      "value": "https://www.crestviewcommonsapts.com?utm_knock=dirmail"
    },
    {
      "ID": "custom_knock_flyers_title",
      "type": "STRING",
      "value": "Flyers"
    },
    {
      "ID": "custom_knock_ppcnk_number",
      "type": "STRING",
      "value": "580-263-5666"
    },
    {
      "ID": "custom_knock_propbro_link",
      "type": "STRING",
      "value": "https://www.crestviewcommonsapts.com?utm_knock=propbro"
    },
    {
      "ID": "custom_knock_chatgpt_title",
      "type": "STRING",
      "value": "Chat GPT"
    },
    {
      "ID": "custom_knock_company_token",
      "type": "STRING",
      "value": "dbb65032104511ee8efd1217b1b18aa3"
    },
    {
      "ID": "custom_knock_dirmail_title",
      "type": "STRING",
      "value": "Direct Mailer"
    },
    {
      "ID": "custom_knock_flyers_number",
      "type": "STRING",
      "value": "580-560-7850"
    },
    {
      "ID": "custom_knock_propbro_title",
      "type": "STRING",
      "value": "Property Brochure"
    },
    {
      "ID": "custom_knock_revcards_link",
      "type": "STRING",
      "value": "https://www.crestviewcommonsapts.com?utm_knock=revcards"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_knock_chatgpt_number",
      "type": "STRING",
      "value": "580-722-1531"
    },
    {
      "ID": "custom_knock_dirmail_number",
      "type": "STRING",
      "value": "580-219-5236"
    },
    {
      "ID": "custom_knock_propbro_number",
      "type": "STRING",
      "value": "580-530-4990"
    },
    {
      "ID": "custom_knock_revcards_title",
      "type": "STRING",
      "value": "Review Cards"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "turnkey"
    },
    {
      "ID": "custom_knock_revcards_number",
      "type": "STRING",
      "value": "580-264-8393"
    },
    {
      "ID": "custom_knock_maintenance_link",
      "type": "STRING",
      "value": "https://www.crestviewcommonsapts.com?utm_knock=maintenance"
    },
    {
      "ID": "custom_knock_maintenance_title",
      "type": "STRING",
      "value": "Maintenance"
    },
    {
      "ID": "custom_knock_tour_button_popup",
      "type": "STRING",
      "value": "<button onclick=\"event.preventDefault(); knockDoorway.openScheduling();\">Book tour</button>"
    },
    {
      "ID": "custom_knock_maintenance_number",
      "type": "STRING",
      "value": "580-633-6173"
    },
    {
      "ID": "custom_ppc_tracking_phone_number",
      "type": "STRING",
      "value": "580-316-5445"
    }
  ],
  "custom_csm": "cameron@repli360.com",
  "custom_qb_id": "5824",
  "custom_repli_id": "10636273150",
  "custom_realpage_id": "5599107",
  "custom_knock_a_link": "https://www.crestviewcommonsapts.com?utm_knock=a",
  "custom_knock_g_link": "https://www.crestviewcommonsapts.com?utm_knock=g",
  "custom_knock_r_link": "https://www.crestviewcommonsapts.com?utm_knock=r",
  "custom_knock_w_link": "https://www.crestviewcommonsapts.com?utm_knock=w",
  "custom_google_gtm_id": "GTM-KT3WZDDR",
  "custom_knock_a_title": "Apartments.com",
  "custom_knock_cl_link": "https://www.crestviewcommonsapts.com?utm_knock=cl",
  "custom_knock_fb_link": "https://www.crestviewcommonsapts.com?utm_knock=fb",
  "custom_knock_fl_link": "https://www.crestviewcommonsapts.com?utm_knock=fl",
  "custom_knock_fr_link": "https://www.crestviewcommonsapts.com?utm_knock=fr",
  "custom_knock_g_title": "Google",
  "custom_knock_gp_link": "https://www.crestviewcommonsapts.com?utm_knock=gp",
  "custom_knock_r_title": "Rent.com",
  "custom_knock_w_title": "Property Website",
  "custom_knock_a_number": "580-325-3959",
  "custom_knock_ads_link": "https://www.crestviewcommonsapts.com?utm_knock=ads",
  "custom_knock_cl_title": "Craigslist",
  "custom_knock_fb_title": "Facebook",
  "custom_knock_fl_title": "Flag",
  "custom_knock_fr_title": "ForRent",
  "custom_knock_g_number": "580-238-5704",
  "custom_knock_gp_title": "Google (paid)",
  "custom_knock_lcs_link": "https://www.crestviewcommonsapts.com?utm_knock=lcs",
  "custom_knock_lgp_link": "https://www.crestviewcommonsapts.com?utm_knock=lgp",
  "custom_knock_ppn_link": "https://www.crestviewcommonsapts.com?utm_knock=ppn",
  "custom_knock_psa_link": "https://www.crestviewcommonsapts.com?utm_knock=psa",
  "custom_knock_r_number": "580-741-3098",
  "custom_knock_w_number": "580-789-2906",
  "custom_knock_ads_title": "META Social Ads",
  "custom_knock_cl_number": "580-263-7256",
  "custom_knock_fb_number": "580-309-5064",
  "custom_knock_fl_number": "580-217-7274",
  "custom_knock_fr_number": "580-263-7590",
  "custom_knock_gp_number": "580-316-5445",
  "custom_knock_lcs_title": "Local Search",
  "custom_knock_lgp_title": "LE Google Performance Max",
  "custom_knock_osoc_link": "https://www.crestviewcommonsapts.com?utm_knock=osoc",
  "custom_knock_ppn_title": "Property Phone Number",
  "custom_knock_psa_title": "Paid Social Ads",
  "custom_ads_subscription": "none",
  "custom_knock_ads_number": "580-238-2690",
  "custom_knock_bcard_link": "https://www.crestviewcommonsapts.com?utm_knock=bcard",
  "custom_knock_cfres_link": "https://www.crestviewcommonsapts.com?utm_knock=cfres",
  "custom_knock_company_id": "2416",
  "custom_knock_lcs_number": "580-324-0858",
  "custom_knock_lgp_number": "580-403-5454",
  "custom_knock_osoc_title": "Organic Social",
  "custom_knock_ppcnk_link": "https://www.crestviewcommonsapts.com?utm_knock=ppcnk",
  "custom_knock_ppn_number": "580-633-3722",
  "custom_knock_psa_number": "580-741-3327",
  "custom_seo_subscription": "full_stack",
  "custom_knock_bcard_title": "Business Card",
  "custom_knock_cfres_title": "Corporate Website",
  "custom_knock_flyers_link": "https://www.crestviewcommonsapts.com?utm_knock=flyers",
  "custom_knock_osoc_number": "580-219-4983",
  "custom_knock_ppcnk_title": "PPC - Nonbrand Keywords",
  "custom_pet_screening_url": "https://app.petscreening.com/",
  "custom_hubspot_company_id": "45778902314",
  "custom_knock_bcard_number": "580-633-7130",
  "custom_knock_cfres_number": "580-896-4441",
  "custom_knock_chatgpt_link": "https://www.crestviewcommonsapts.com?utm_knock=CHATGPT",
  "custom_knock_community_id": "1f0f1a2b47afb9e1",
  "custom_knock_dirmail_link": "https://www.crestviewcommonsapts.com?utm_knock=dirmail",
  "custom_knock_flyers_title": "Flyers",
  "custom_knock_ppcnk_number": "580-263-5666",
  "custom_knock_propbro_link": "https://www.crestviewcommonsapts.com?utm_knock=propbro",
  "custom_knock_chatgpt_title": "Chat GPT",
  "custom_knock_company_token": "dbb65032104511ee8efd1217b1b18aa3",
  "custom_knock_dirmail_title": "Direct Mailer",
  "custom_knock_flyers_number": "580-560-7850",
  "custom_knock_propbro_title": "Property Brochure",
  "custom_knock_revcards_link": "https://www.crestviewcommonsapts.com?utm_knock=revcards",
  "custom_social_subscription": "none",
  "custom_knock_chatgpt_number": "580-722-1531",
  "custom_knock_dirmail_number": "580-219-5236",
  "custom_knock_propbro_number": "580-530-4990",
  "custom_knock_revcards_title": "Review Cards",
  "custom_website_subscription": "turnkey",
  "custom_knock_revcards_number": "580-264-8393",
  "custom_knock_maintenance_link": "https://www.crestviewcommonsapts.com?utm_knock=maintenance",
  "custom_knock_maintenance_title": "Maintenance",
  "custom_knock_tour_button_popup": "<button onclick=\"event.preventDefault(); knockDoorway.openScheduling();\">Book tour</button>",
  "custom_knock_maintenance_number": "580-633-6173",
  "custom_ppc_tracking_phone_number": "580-316-5445",
  "custom_audioeye_site_id": "443d98d7-ae46-413c-bc09-0fdf604ccf95",
  "custom_audioeye_site_hash": "96f75f5ac29ceaa397407a857c85f220"
};

export const generatedAt = '2026-11-03T21:40:33.395Z';
